import React, { Component } from "react";
import { injectIntl } from "react-intl";
import {
  Card,
  CardBody,
  Row,
  Nav,
  NavItem,
  NavLink,
  TabContent,
  TabPane,
  Button,
  Alert,
  Popover,
  PopoverBody,
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  FormGroup,
  Label,
  Input,
} from "reactstrap";
import { Colxx, Separator } from "../../../components/common/CustomBootstrap";
import IntlMessages from "../../../helpers/IntlMessages";
import { NotificationManager } from "../../../components/common/react-notifications";
import Select from "react-select";
import Breadcrumb from "../../../containers/navs/Breadcrumb";
import Switch from "rc-switch";
import { END_POINT } from "../../../constants/defaultValues";
import {
  buildSilentPrintHtml,
  getStoredPrintPaperWidthMm,
  normalizePrintPaperWidthMm,
  NotificatioErrController,
} from "../../../helpers/Utils";
import axios from "axios";
import classnames from "classnames";
import { connect } from "react-redux";
import { setSearchContext, setMenuLayoutType } from "../../../redux/actions";
import ShippingSettingsContent from "../settings/shipping";
import CustomerSettingsContent from "../../../containers/pages/customer/Setting";
import StaffSettingsContent from "../../../containers/pages/user-staff/Setting";
import PartnerManagement from "../settings/PartnerManagement";
import WebhookManagement from "../settings/WebhookManagement";
import QuickReplySettings from "../settings/QuickReplySettings";
import AutoReplySettings from "../settings/AutoReplySettings";
import AIConfiguration from "../settings/AIConfiguration";
import {
  downloadWindowsKioskLauncher,
  getOrCreateWebPrintTerminalId,
  getWebPrintDocumentType,
  getWebPrintMode,
  setWebPrintDocumentType,
  setWebPrintMode,
} from "../../../helpers/WebPrintTerminal";
import ShopeeV2Api, {
  createIdempotencyKey,
  getShopeeJobIds,
} from "../../../services/shopeeV2";

class Setting extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isLoading: false,
      printers: [],
      selectedPrinter: localStorage.getItem("defaultPrinter") || "",
      terminalId: "",
      onlinePrintTerminalId: "",
      onlineCustomerTerminalId: "",
      onlineKitchenTerminalId: "",
      webPrintMode: getWebPrintMode(),
      webPrintDocumentType: getWebPrintDocumentType(),
      kioskBrowser: "edge",
      onlineCustomerPrinter:
        localStorage.getItem("onlineCustomerPrinter") ||
        localStorage.getItem("defaultPrinter") ||
        "",
      onlineKitchenPrinter:
        localStorage.getItem("onlineKitchenPrinter") ||
        localStorage.getItem("defaultPrinter") ||
        "",
      customerPaperWidthMm: String(getStoredPrintPaperWidthMm("customer")),
      kitchenPaperWidthMm: String(getStoredPrintPaperWidthMm("kitchen")),
      activeTab: "1",
      switchChecked: {
        switchCheckedBill: false,
        switchCheckedBillQr: false,
        switchCheckedBillBar: false,
        switchCheckedTemBar: false,
        switchCheckedTemCashier: false,
        switchCheckedOrderOne: false,
        switchCheckedOrderTwo: false,
        switchCheckedOrderThree: false,
        switchCheckedOrderFour: false,
        save_provisional_when_print: true,
        print_customer_provisional: true,
        print_customer_invoice: true,
        guest_require_customer_info: true,
        auto_print_online_customer: false,
        auto_print_online_kitchen: false,
      },
      fontSize: parseInt(localStorage.getItem("appFontSize")) || 14,
      // Social connections
      facebookPages: [],
      zaloOAs: [],
      loadingSocial: false,
      socialError: null,
      socialSuccess: null,
      // Manual token
      showManualToken: false,
      manualToken: "",
      connectingManualToken: false,
      manualTokenGuideOpen: false,
      // Preview pages (2-step flow)
      previewPages: [],
      previewLoading: false,
      selectedPageIds: new Set(),
      previewTokenType: null,
      // Guide popovers
      facebookGuideOpen: false,
      zaloGuideOpen: false,
      // E-commerce connections
      shopeeShops: [],
      tiktokShops: [],
      loadingEcommerce: false,
      ecommerceError: null,
      ecommerceSuccess: null,
      shopeeGuideOpen: false,
      tiktokGuideOpen: false,
      // Dropdown state for each shop
      shopeeDropdownOpen: {},
      tiktokDropdownOpen: {},
      // Syncing state
      syncingShopee: {},
      syncingTiktok: {},
      // E-Invoice config
      eInvoiceConfig: {
        provider: "misa",
        api_url: "https://testapi.meinvoice.vn",
        username: "",
        password: "",
        company_tax_id: "",
        company_name: "",
        company_address: "",
        company_phone: "",
        company_email: "",
        company_bank_account: "",
        company_bank_name: "",
        invoice_series: "",
        vat_rate: 10,
        // Signing configuration
        sign_type: 1, // 1=USB Token, 2=HSM, 3=eSign
        esign_provider: "",
        esign_username: "",
        esign_password: "",
        esign_serial: "",
        // SePay config
        sepay_client_id: "",
        sepay_client_secret: "",
        sepay_account_id: "",
        template_code: "",
        auto_issue: false,
        create_draft_when_not_issue: true,
      },
      sepayAccounts: [],
      sepayTemplates: [],
      sepayQuota: null,
      loadingSepayInfo: false,
      testingConnection: false,
      testConnectionResult: null,
      loadingEInvoice: false,
      eInvoiceError: null,
      eInvoiceSuccess: null,
      sepayGuideOpen: false /* SePay guide state */,
      misaGuideOpen: false /* MISA guide state */,
      // Email SMTP Config
      // enabled = true: dùng email VMASS mặc định
      // enabled = false: dùng email riêng (hiển thị form)
      emailConfig: {
        enabled: true, // mặc định dùng email VMASS
        type: "gmail", // 'gmail' or 'smtp'
        email: "",
        password: "",
        smtp_host: "",
        smtp_port: 465,
        smtp_secure: true,
      },
      loadingEmailConfig: false,
      emailConfigError: null,
      emailConfigSuccess: null,
      showEmailPassword: false,
      showEmailPassword: false,
      emailGuideOpen: false,
      // License info
      license: null,
      report_time: [],
      shift_required: false,
    };
  }

  reportTimeOptions = Array.from({ length: 24 }, (_, i) => ({
    value: i,
    label: `${i}:00`,
  }));

  componentDidMount() {
    // Set search context to 'settings' which resets keyword to empty
    if (this.props.setSearchContext) {
      this.props.setSearchContext("settings");
    }

    try {
      this.settingRender();
      const savedFontSize = localStorage.getItem("appFontSize") || 14;
      document.documentElement.style.setProperty(
        "--app-font-size",
        `${savedFontSize}px`,
      );
      // Load license first, then load other configs based on permission
      this.loadUserLicense().then(() => {
        this.loadSocialConnections();
        this.loadEcommerceConnections();
        this.loadEInvoiceConfig();
      });
      this.loadEmailConfig();
      if (window.electronAPI) {
        window.electronAPI.getPrinters().then((printers) => {
          this.setState({ printers });
        });
        window.electronAPI.getTerminalId().then((terminalId) => {
          this.setState({ terminalId });
        });
      } else {
        this.setState({ terminalId: getOrCreateWebPrintTerminalId() });
      }
    } catch (error) {
      console.error("Error loading settings:", error);
    }
  }

  toggleTab = (tab) => {
    if (this.state.activeTab !== tab) {
      this.setState({ activeTab: tab });
    }
  };

  loadUserLicense = async () => {
    try {
      const tokenStr = localStorage.getItem("access_token");
      const response = await axios.get(`${END_POINT}/user-license`, {
        headers: { Authorization: `Bearer ${tokenStr}` },
      });
      // API returns { status: 200, data: { ...license... } }
      if (response.data && response.data.data) {
        this.setState({ license: response.data.data });
      }
    } catch (err) {
      console.error("Error loading license:", err);
    }
  };

  checkPermission = (requiredPackage) => {
    const { license } = this.state;
    if (!license) return false;

    const ranks = {
      free: 0,
      basic: 1,
      pro: 2,
      pro_auto: 3,
      enterprise: 4,
    };

    const currentPackage = (license.purchased_package || "free").toLowerCase();
    const currentRank = ranks[currentPackage] || 0;
    const requiredRank = ranks[requiredPackage] || 0;

    // Check expiry only for paid packages
    if (currentRank > 0 && license.expired_date) {
      const today = new Date().toISOString().split("T")[0];
      if (license.expired_date < today) {
        // Expired -> Degrade to Free (Rank 0)
        return 0 >= requiredRank;
      }
    }

    return currentRank >= requiredRank;
  };

  getAuthConfig = () => {
    const tokenStr = localStorage.getItem("access_token");
    return { headers: { Authorization: `Bearer ${tokenStr}` } };
  };

  settingRender() {
    let tokenStr = localStorage.getItem("access_token");
    axios
      .get(`${END_POINT + "/setting"}`, {
        headers: { Authorization: `Bearer ${tokenStr}` },
      })
      .then((res) => res.data)
      .then(async (data) => {
        const setting = data.data;
        if (data) {
          await this.setState((prevState) => ({
            ...prevState,
            isLoading: true,
            switchChecked: {
              ...prevState,
              switchCheckedBill: setting.bill_cashier,
              switchCheckedBillQr: setting.bill_qr,
              switchCheckedBillBar: setting.bill_bar,
              switchCheckedTemBar: setting.tem_bar,
              switchCheckedTemCashier: setting.tem_cashier,
              switchCheckedOrderOne: setting.order_processing_one,
              switchCheckedOrderTwo: setting.order_processing_two,
              switchCheckedOrderThree: setting.order_processing_three,
              switchCheckedOrderFour: setting.order_processing_four,
              save_provisional_when_print:
                setting.save_provisional_when_print !== undefined
                  ? setting.save_provisional_when_print
                  : true,
              print_customer_provisional:
                setting.print_customer_provisional !== undefined
                  ? setting.print_customer_provisional
                  : true,
              print_customer_invoice:
                setting.print_customer_invoice !== undefined
                  ? setting.print_customer_invoice
                  : true,
              guest_require_customer_info:
                setting.guest_require_customer_info !== undefined
                  ? setting.guest_require_customer_info
                  : true,
              auto_print_online_customer:
                setting.auto_print_online_customer === true,
              auto_print_online_kitchen:
                setting.auto_print_online_kitchen === true,
            },
            onlinePrintTerminalId: setting.online_print_terminal_id || "",
            onlineCustomerTerminalId:
              setting.online_print_customer_terminal_id ||
              setting.online_print_terminal_id ||
              "",
            onlineKitchenTerminalId:
              setting.online_print_kitchen_terminal_id ||
              setting.online_print_terminal_id ||
              "",
            report_time: String(setting.report_time || "21")
              .split(",")
              .map((val) =>
                this.reportTimeOptions.find(
                  (opt) => opt.value === parseInt(val),
                ),
              )
              .filter(Boolean),
            shift_required: setting.shift_required || false,
          }));
        } else {
          NotificatioErrController(
            this.props.intl.formatMessage({
              id: "settings.notification.no-data",
            }),
          );
        }
      })
      .catch((err) => {
        NotificatioErrController(err.response?.data?.responseText);
      });
  }

  loadSocialConnections = async () => {
    // Check permission: social features require pro_auto
    if (!this.checkPermission("pro_auto")) {
      return;
    }
    const user_id = localStorage.getItem("b");
    this.setState({ loadingSocial: true });

    try {
      // Load Facebook Pages
      const fbResponse = await axios.get(
        `${END_POINT}/api/facebook/pages?user_id=${user_id}`,
        this.getAuthConfig(),
      );
      // Load Zalo OAs
      const zaloResponse = await axios.get(
        `${END_POINT}/api/zalo/oas?user_id=${user_id}`,
        this.getAuthConfig(),
      );

      this.setState({
        facebookPages: fbResponse.data.data || [],
        zaloOAs: zaloResponse.data.data || [],
        loadingSocial: false,
      });
    } catch (err) {
      console.error("Error loading social connections:", err);
      this.setState({ loadingSocial: false });
    }
  };

  handleConnectFacebook = async () => {
    const user_id = localStorage.getItem("b");
    const redirect_url = window.location.href.split("?")[0];
    try {
      const response = await axios.get(
        `${END_POINT}/api/facebook/login?user_id=${user_id}&redirect_url=${encodeURIComponent(
          redirect_url,
        )}`,
        this.getAuthConfig(),
      );
      if (response.data.authUrl) {
        window.location.href = response.data.authUrl;
      }
    } catch (err) {
      this.setState({
        socialError: this.props.intl.formatMessage({
          id: "settings.social.fb.connect-error",
        }),
      });
    }
  };

  // Step 1: Preview available pages from token
  handlePreviewPages = async () => {
    const { manualToken } = this.state;
    if (!manualToken || !manualToken.trim()) {
      this.setState({
        socialError: this.props.intl.formatMessage({
          id: "facebook.manual.error-empty",
        }),
      });
      return;
    }

    this.setState({ previewLoading: true, socialError: null, previewPages: [] });

    try {
      const user_id = localStorage.getItem("b");
      const tokenStr = localStorage.getItem("access_token");
      const response = await axios.post(
        `${END_POINT}/api/facebook/preview-pages`,
        {
          user_id,
          page_access_token: manualToken.trim(),
        },
        {
          headers: { Authorization: `Bearer ${tokenStr}` },
        },
      );

      const pages = response.data.data || [];
      const tokenType = response.data.token_type;

      // Auto-select all pages by default
      const allIds = new Set(pages.map((p) => p.page_id));

      this.setState({
        previewLoading: false,
        previewPages: pages,
        selectedPageIds: allIds,
        previewTokenType: tokenType,
      });
    } catch (err) {
      const errorMsg =
        err.response?.data?.error ||
        this.props.intl.formatMessage({
          id: "facebook.manual.error-failed",
        });
      this.setState({
        previewLoading: false,
        socialError: errorMsg,
      });
    }
  };

  // Step 2: Connect only selected pages
  handleConnectSelectedPages = async () => {
    const { manualToken, selectedPageIds } = this.state;
    if (selectedPageIds.size === 0) {
      this.setState({
        socialError: this.props.intl.formatMessage({
          id: "facebook.manual.error-no-selection",
        }),
      });
      return;
    }

    this.setState({ connectingManualToken: true, socialError: null });

    try {
      const user_id = localStorage.getItem("b");
      const tokenStr = localStorage.getItem("access_token");
      const response = await axios.post(
        `${END_POINT}/api/facebook/manual-connect`,
        {
          user_id,
          page_access_token: manualToken.trim(),
          selected_page_ids: Array.from(selectedPageIds),
        },
        {
          headers: { Authorization: `Bearer ${tokenStr}` },
        },
      );

      this.setState({
        connectingManualToken: false,
        manualToken: "",
        showManualToken: false,
        previewPages: [],
        selectedPageIds: new Set(),
        previewTokenType: null,
        socialSuccess: response.data.message,
      });
      this.loadSocialConnections();
    } catch (err) {
      const errorMsg =
        err.response?.data?.error ||
        this.props.intl.formatMessage({
          id: "facebook.manual.error-failed",
        });
      this.setState({
        connectingManualToken: false,
        socialError: errorMsg,
      });
    }
  };

  // Toggle page selection
  togglePageSelection = (pageId) => {
    this.setState((prev) => {
      const newSet = new Set(prev.selectedPageIds);
      if (newSet.has(pageId)) {
        newSet.delete(pageId);
      } else {
        newSet.add(pageId);
      }
      return { selectedPageIds: newSet };
    });
  };

  // Select/Deselect all pages
  toggleSelectAll = () => {
    this.setState((prev) => {
      const allSelected = prev.selectedPageIds.size === prev.previewPages.length;
      if (allSelected) {
        return { selectedPageIds: new Set() };
      }
      return {
        selectedPageIds: new Set(prev.previewPages.map((p) => p.page_id)),
      };
    });
  };

  handleConnectZalo = async () => {
    const user_id = localStorage.getItem("b");
    const redirect_url = window.location.href.split("?")[0];
    try {
      const response = await axios.get(
        `${END_POINT}/api/zalo/login?user_id=${user_id}&redirect_url=${encodeURIComponent(
          redirect_url,
        )}`,
        this.getAuthConfig(),
      );
      if (response.data.authUrl) {
        window.location.href = response.data.authUrl;
      }
    } catch (err) {
      this.setState({
        socialError: this.props.intl.formatMessage({
          id: "settings.social.zalo.connect-error",
        }),
      });
    }
  };

  handleDisconnectFacebook = async (page_id) => {
    if (
      !window.confirm(
        this.props.intl.formatMessage({
          id: "settings.social.fb.confirm-disconnect",
        }),
      )
    )
      return;
    try {
      const user_id = localStorage.getItem("b");
      await axios.delete(
        `${END_POINT}/api/facebook/pages/${page_id}?user_id=${user_id}`,
        this.getAuthConfig(),
      );
      this.setState({
        socialSuccess: this.props.intl.formatMessage({
          id: "settings.social.fb.disconnect-success",
        }),
      });
      this.loadSocialConnections();
    } catch (err) {
      this.setState({
        socialError: this.props.intl.formatMessage({
          id: "settings.social.fb.disconnect-error",
        }),
      });
    }
  };

  handleDisconnectZalo = async (oa_id) => {
    if (
      !window.confirm(
        this.props.intl.formatMessage({
          id: "settings.social.zalo.confirm-disconnect",
        }),
      )
    )
      return;
    try {
      const user_id = localStorage.getItem("b");
      await axios.delete(
        `${END_POINT}/api/zalo/oas/${oa_id}?user_id=${user_id}`,
        this.getAuthConfig(),
      );
      this.setState({
        socialSuccess: this.props.intl.formatMessage({
          id: "settings.social.zalo.disconnect-success",
        }),
      });
      this.loadSocialConnections();
    } catch (err) {
      this.setState({
        socialError: this.props.intl.formatMessage({
          id: "settings.social.zalo.disconnect-error",
        }),
      });
    }
  };

  // E-commerce Methods
  loadEcommerceConnections = async () => {
    // Check permission: e-commerce features require pro
    if (!this.checkPermission("pro")) {
      return;
    }
    try {
      this.setState({ loadingEcommerce: true });
      const user_id = localStorage.getItem("b");
      const authConfig = this.getAuthConfig();

      const [shopeeResponse, tiktokResponse] = await Promise.all([
        ShopeeV2Api.shops().catch(() => ({ data: [] })),
        axios
          .get(`${END_POINT}/api/tiktok/shops?user_id=${user_id}`, authConfig)
          .catch(() => ({ data: { data: [] } })),
      ]);

      this.setState({
        shopeeShops: shopeeResponse.data || [],
        tiktokShops: tiktokResponse.data.data || [],
        loadingEcommerce: false,
      });
    } catch (err) {
      console.error("Error loading e-commerce connections:", err);
      this.setState({ loadingEcommerce: false });
    }
  };

  handleConnectShopee = async () => {
    try {
      const redirectUrl =
        window.location.pathname || "/app/applications/setting";
      const response = await ShopeeV2Api.authorizationUrl(
        redirectUrl,
      );

      if (response.data && response.data.authorization_url) {
        window.location.href = response.data.authorization_url;
      } else {
        throw new Error("Missing Shopee auth URL");
      }
    } catch (err) {
      this.setState({
        ecommerceError: this.props.intl.formatMessage({
          id: "settings.ecommerce.shopee.connect-error",
        }),
      });
    }
  };

  handleDisconnectShopee = async (shop_id) => {
    if (
      !window.confirm(
        this.props.intl.formatMessage({
          id: "settings.ecommerce.shop.confirm-disconnect",
        }),
      )
    )
      return;
    try {
      await ShopeeV2Api.disconnectShop(
        String(shop_id),
        createIdempotencyKey(`settings-disconnect-${shop_id}`),
      );
      this.setState({
        ecommerceSuccess: this.props.intl.formatMessage({
          id: "settings.ecommerce.shop.disconnect-success",
        }),
      });
      this.loadEcommerceConnections();
    } catch (err) {
      this.setState({
        ecommerceError: this.props.intl.formatMessage({
          id: "settings.ecommerce.shop.disconnect-error",
        }),
      });
    }
  };

  handleConnectTiktok = async () => {
    try {
      const user_id = localStorage.getItem("b");
      const redirect_url = window.location.href.split("?")[0];
      const response = await axios.get(
        `${END_POINT}/api/tiktok/login?user_id=${user_id}&redirect_url=${encodeURIComponent(
          redirect_url,
        )}`,
        this.getAuthConfig(),
      );

      if (response.data.authUrl) {
        window.location.href = response.data.authUrl;
      }
    } catch (err) {
      this.setState({
        ecommerceError: this.props.intl.formatMessage({
          id: "settings.ecommerce.tiktok.connect-error",
        }),
      });
    }
  };

  handleDisconnectTiktok = async (shop_id) => {
    if (
      !window.confirm(
        this.props.intl.formatMessage({
          id: "settings.ecommerce.shop.confirm-disconnect",
        }),
      )
    )
      return;
    try {
      const user_id = localStorage.getItem("b");
      await axios.delete(
        `${END_POINT}/api/tiktok/shops/${shop_id}?user_id=${user_id}`,
        this.getAuthConfig(),
      );
      this.setState({
        ecommerceSuccess: this.props.intl.formatMessage({
          id: "settings.ecommerce.tiktok.disconnect-success",
        }),
      });
      this.loadEcommerceConnections();
    } catch (err) {
      this.setState({
        ecommerceError: this.props.intl.formatMessage({
          id: "settings.ecommerce.tiktok.disconnect-error",
        }),
      });
    }
  };

  // Toggle dropdown for Shopee shop
  toggleShopeeDropdown = (shopId) => {
    this.setState((prev) => ({
      shopeeDropdownOpen: {
        ...prev.shopeeDropdownOpen,
        [shopId]: !prev.shopeeDropdownOpen[shopId],
      },
    }));
  };

  // Toggle dropdown for TikTok shop
  toggleTiktokDropdown = (shopId) => {
    this.setState((prev) => ({
      tiktokDropdownOpen: {
        ...prev.tiktokDropdownOpen,
        [shopId]: !prev.tiktokDropdownOpen[shopId],
      },
    }));
  };

  // Sync products from Shopee
  handleSyncShopeeProducts = async (shop_id) => {
    try {
      this.setState((prev) => ({
        syncingShopee: { ...prev.syncingShopee, [shop_id]: "products" },
        ecommerceError: null,
        ecommerceSuccess: null,
      }));
      const response = await ShopeeV2Api.importCatalog(
        String(shop_id),
        null,
        createIdempotencyKey(`settings-catalog-import-${shop_id}`),
      );
      if (!getShopeeJobIds(response).length) {
        throw new Error("Shopee catalog import job was not created");
      }
      this.setState({
        ecommerceSuccess: this.props.intl.formatMessage({
          id: "settings.ecommerce.product-import-success",
        }),
        syncingShopee: {},
      });
    } catch (err) {
      const responseData = err && err.response && err.response.data;
      this.setState({
        ecommerceError:
          (responseData &&
            responseData.error &&
            responseData.error.message) ||
          (responseData && responseData.responseText) ||
          this.props.intl.formatMessage({
            id: "settings.ecommerce.product-import-error",
          }),
        syncingShopee: {},
      });
    }
  };

  // Sync orders from Shopee
  handleSyncShopeeOrders = async (shop_id) => {
    try {
      this.setState((prev) => ({
        syncingShopee: { ...prev.syncingShopee, [shop_id]: "orders" },
        ecommerceError: null,
        ecommerceSuccess: null,
      }));
      const response = await ShopeeV2Api.syncOrders(
        String(shop_id),
        createIdempotencyKey(`settings-order-sync-${shop_id}`),
      );
      if (!getShopeeJobIds(response).length) {
        throw new Error("Shopee order sync job was not created");
      }
      this.setState({
        ecommerceSuccess: this.props.intl.formatMessage({
          id: "settings.ecommerce.order-sync-success",
        }),
        syncingShopee: {},
      });
    } catch (err) {
      const responseData = err && err.response && err.response.data;
      this.setState({
        ecommerceError:
          (responseData &&
            responseData.error &&
            responseData.error.message) ||
          (responseData && responseData.responseText) ||
          this.props.intl.formatMessage({
            id: "settings.ecommerce.order-sync-error",
          }),
        syncingShopee: {},
      });
    }
  };

  // Sync products from TikTok
  handleSyncTiktokProducts = async (shop_id) => {
    try {
      this.setState((prev) => ({
        syncingTiktok: { ...prev.syncingTiktok, [shop_id]: "products" },
      }));
      const user_id = localStorage.getItem("b");
      const response = await axios.post(
        `${END_POINT}/api/tiktok/products/import`,
        { user_id, shop_id },
      );
      this.setState({
        ecommerceSuccess:
          response.data.message ||
          this.props.intl.formatMessage({
            id: "settings.ecommerce.product-import-success",
          }),
        syncingTiktok: {},
      });
    } catch (err) {
      this.setState({
        ecommerceError: this.props.intl.formatMessage({
          id: "settings.ecommerce.product-import-error",
        }),
        syncingTiktok: {},
      });
    }
  };

  // Sync orders from TikTok
  handleSyncTiktokOrders = async (shop_id) => {
    try {
      this.setState((prev) => ({
        syncingTiktok: { ...prev.syncingTiktok, [shop_id]: "orders" },
      }));
      const user_id = localStorage.getItem("b");
      const response = await axios.post(`${END_POINT}/api/tiktok/orders/sync`, {
        user_id,
        shop_id,
      });
      this.setState({
        ecommerceSuccess:
          response.data.message ||
          this.props.intl.formatMessage({
            id: "settings.ecommerce.order-sync-success",
          }),
        syncingTiktok: {},
      });
    } catch (err) {
      this.setState({
        ecommerceError: this.props.intl.formatMessage({
          id: "settings.ecommerce.order-sync-error",
        }),
        syncingTiktok: {},
      });
    }
  };

  // E-Invoice Config Methods
  loadEInvoiceConfig = async () => {
    // Check permission: e-invoice features require pro
    if (!this.checkPermission("pro")) {
      return;
    }
    try {
      const user_id = localStorage.getItem("b");
      const response = await axios.get(
        `${END_POINT}/api/einvoice/config?user_id=${user_id}`,
      );
      if (response.data.data) {
        const configData = response.data.data;
        this.setState({
          eInvoiceConfig: {
            ...this.state.eInvoiceConfig,
            ...configData,
          },
        });

        // If SePay provider with saved account_id, auto-load accounts and templates
        if (configData.provider === "sepay" && configData.sepay_account_id) {
          // Load accounts first
          await this.loadSepayAccounts();
          // Then load templates for the saved account
          await this.loadSepayTemplatesForAccount(configData.sepay_account_id);
        }
      }
    } catch (err) {
      console.error("Error loading e-invoice config:", err);
    }
  };

  // Load templates for a specific account (without changing account_id in state)
  loadSepayTemplatesForAccount = async (accountId) => {
    try {
      const user_id = localStorage.getItem("b");
      const tokenStr = localStorage.getItem("access_token");
      const response = await axios.get(
        `${END_POINT}/api/einvoice/sepay/accounts/${accountId}?user_id=${user_id}`,
        { headers: { Authorization: `Bearer ${tokenStr}` } },
      );

      if (response.data && response.data.data) {
        const templates = response.data.data.templates || [];
        this.setState({ sepayTemplates: templates });
      }
    } catch (error) {
      console.error("Load SePay templates error:", error);
    }
  };

  handleEInvoiceConfigChange = (field, value) => {
    // When provider changes, reset api_url to default for that provider
    if (field === "provider") {
      const defaultUrls = {
        misa: "https://testapi.meinvoice.vn",
        sepay: "https://einvoice-api-sandbox.sepay.vn",
      };
      this.setState((prev) => ({
        eInvoiceConfig: {
          ...prev.eInvoiceConfig,
          provider: value,
          api_url: defaultUrls[value] || prev.eInvoiceConfig.api_url,
        },
      }));
    } else {
      this.setState((prev) => ({
        eInvoiceConfig: { ...prev.eInvoiceConfig, [field]: value },
      }));
    }
  };

  saveEInvoiceConfig = async () => {
    try {
      this.setState({ loadingEInvoice: true, eInvoiceError: null });
      const user_id = localStorage.getItem("b");
      const response = await axios.post(`${END_POINT}/api/einvoice/config`, {
        user_id,
        ...this.state.eInvoiceConfig,
      });
      this.setState({ loadingEInvoice: false });
      // Show success notification popup
      NotificationManager.primary(
        response.data.message ||
          this.props.intl.formatMessage({
            id: "settings.einvoice.save-success",
          }),
        this.props.intl.formatMessage({ id: "settings.einvoice.title" }),
        3000,
        null,
        null,
        "",
      );
    } catch (err) {
      this.setState({
        loadingEInvoice: false,
        eInvoiceError: this.props.intl.formatMessage({
          id: "settings.einvoice.save-error",
        }),
      });
    }
  };

  testEInvoiceConnection = async () => {
    try {
      this.setState({
        testingConnection: true,
        testConnectionResult: null,
      });

      const user_id = localStorage.getItem("b");
      const { eInvoiceConfig } = this.state;

      const response = await axios.post(
        `${END_POINT}/api/einvoice/test-connection`,
        {
          user_id,
          provider: eInvoiceConfig.provider,
          api_url: eInvoiceConfig.api_url,
          username: eInvoiceConfig.username,
          password: eInvoiceConfig.password,
        },
      );

      this.setState({
        testingConnection: false,
        testConnectionResult: {
          success: response.data.success,
          message: response.data.success
            ? this.props.intl.formatMessage({
                id: "settings.einvoice.test-success",
              })
            : response.data.message ||
              this.props.intl.formatMessage({
                id: "settings.einvoice.test-fail",
              }),
        },
      });
    } catch (err) {
      this.setState({
        testingConnection: false,
        testConnectionResult: {
          success: false,
          message:
            err.response?.data?.message ||
            this.props.intl.formatMessage({
              id: "settings.einvoice.test-fail",
            }),
        },
      });
    }
  };

  // ========== SEPAY HELPER METHODS ==========
  loadSepayAccounts = async () => {
    try {
      this.setState({ loadingSepayInfo: true });
      const user_id = localStorage.getItem("b");

      // Note: This relies on the backend using the SAVED config to authenticate.
      // Ideally we should warn the user to SAVE first.
      const tokenStr = localStorage.getItem("access_token");
      const response = await axios.get(
        `${END_POINT}/api/einvoice/sepay/accounts?user_id=${user_id}`,
        { headers: { Authorization: `Bearer ${tokenStr}` } },
      );

      // console.log("[SePay] Accounts Response:", response.data);

      if (response.data && response.data.data) {
        let accounts = response.data.data;
        if (!Array.isArray(accounts)) {
          accounts = [accounts];
        }
        this.setState({
          sepayAccounts: accounts,
          loadingSepayInfo: false,
        });

        // If only one account, auto select
        if (response.data.data.length === 1) {
          this.handleSepayAccountChange(response.data.data[0].id);
        }
      }
    } catch (error) {
      console.error("Load SePay accounts error:", error);
      this.setState({ loadingSepayInfo: false });
      const errorMsg = error.response?.data?.responseText || error.response?.data?.message || error.response?.data?.error || error.message || "Vui lòng lưu cấu hình đúng trước khi tải danh sách tài khoản";
      NotificationManager.error(
        errorMsg,
        "Lỗi tải tài khoản",
        5000,
      );
    }
  };

  handleSepayAccountChange = async (accountId) => {
    // Update config state
    this.handleEInvoiceConfigChange("sepay_account_id", accountId);

    // Load details (templates)
    try {
      this.setState({ loadingSepayInfo: true });
      const user_id = localStorage.getItem("b");
      const tokenStr = localStorage.getItem("access_token");
      const response = await axios.get(
        `${END_POINT}/api/einvoice/sepay/accounts/${accountId}?user_id=${user_id}`,
        { headers: { Authorization: `Bearer ${tokenStr}` } },
      );

      if (response.data && response.data.data) {
        const templates = response.data.data.templates || [];
        this.setState({
          sepayTemplates: templates,
          loadingSepayInfo: false,
        });
      }
    } catch (error) {
      console.error("Load SePay account details error:", error);
      this.setState({ loadingSepayInfo: false });
      const errorMsg = error.response?.data?.responseText || error.response?.data?.message || error.response?.data?.error || error.message || "Không thể tải mẫu hóa đơn của tài khoản này";
      NotificationManager.error(
        errorMsg,
        "Lỗi tải mẫu hóa đơn",
        5000,
      );
    }

    // Also load Quota
    this.loadSepayQuota();
  };

  loadSepayQuota = async () => {
    try {
      const user_id = localStorage.getItem("b");
      const tokenStr = localStorage.getItem("access_token");
      const response = await axios.get(
        `${END_POINT}/api/einvoice/quota?user_id=${user_id}`,
        { headers: { Authorization: `Bearer ${tokenStr}` } },
      );

      if (response.data && response.data.data) {
        this.setState({
          sepayQuota: response.data.data.quota_remaning,
        });
      }
    } catch (error) {
      console.error("Load SePay quota error:", error);
    }
  };

  // ========== EMAIL SMTP CONFIG METHODS ==========
  loadEmailConfig = async () => {
    try {
      const tokenStr = localStorage.getItem("access_token");
      const response = await axios.get(`${END_POINT}/setting`, {
        headers: { Authorization: `Bearer ${tokenStr}` },
      });
      if (response.data.data && response.data.data.email_config) {
        this.setState({
          emailConfig: {
            ...this.state.emailConfig,
            ...response.data.data.email_config,
          },
        });
      }
    } catch (err) {
      console.error("Error loading email config:", err);
    }
  };

  handleEmailConfigChange = (field, value) => {
    this.setState((prev) => ({
      emailConfig: { ...prev.emailConfig, [field]: value },
    }));
  };

  saveEmailConfig = async () => {
    try {
      this.setState({ loadingEmailConfig: true, emailConfigError: null });
      const tokenStr = localStorage.getItem("access_token");
      await axios.put(
        `${END_POINT}/setting`,
        { email_config: this.state.emailConfig },
        { headers: { Authorization: `Bearer ${tokenStr}` } },
      );
      this.setState({
        loadingEmailConfig: false,
        emailConfigSuccess: this.props.intl.formatMessage({
          id: "settings.email.save-success",
        }),
      });
      setTimeout(() => this.setState({ emailConfigSuccess: null }), 3000);
    } catch (err) {
      this.setState({
        loadingEmailConfig: false,
        emailConfigError: this.props.intl.formatMessage({
          id: "settings.email.save-error",
        }),
      });
    }
  };

  testEmailConfig = async () => {
    try {
      this.setState({ loadingEmailConfig: true, emailConfigError: null });
      const tokenStr = localStorage.getItem("access_token");
      const response = await axios.post(
        `${END_POINT}/setting/test-email`,
        { email_config: this.state.emailConfig },
        { headers: { Authorization: `Bearer ${tokenStr}` } },
      );
      this.setState({
        loadingEmailConfig: false,
        emailConfigSuccess:
          response.data.message ||
          this.props.intl.formatMessage({ id: "settings.email.test-success" }),
      });
      setTimeout(() => this.setState({ emailConfigSuccess: null }), 5000);
    } catch (err) {
      this.setState({
        loadingEmailConfig: false,
        emailConfigError:
          err.response?.data?.message ||
          this.props.intl.formatMessage({ id: "settings.email.test-error" }),
      });
    }
  };

  onChange = async (name) => {
    const updatedSwitchChecked = {
      ...this.state.switchChecked,
      [name]: !this.state.switchChecked[name],
    };

    if (
      name === "switchCheckedOrderOne" ||
      name === "switchCheckedOrderTwo" ||
      name === "switchCheckedOrderThree" ||
      name === "switchCheckedOrderFour"
    ) {
      [
        "switchCheckedOrderOne",
        "switchCheckedOrderTwo",
        "switchCheckedOrderThree",
        "switchCheckedOrderFour",
      ].forEach((switchName) => {
        if (switchName !== name) {
          updatedSwitchChecked[switchName] = false;
        }
      });
    }

    this.setState({ switchChecked: updatedSwitchChecked });

    const {
      switchCheckedBill,
      switchCheckedBillQr,
      switchCheckedBillBar,
      switchCheckedTemBar,
      switchCheckedTemCashier,
      switchCheckedOrderOne,
      switchCheckedOrderTwo,
      switchCheckedOrderThree,
      switchCheckedOrderFour,
      save_provisional_when_print,
      print_customer_provisional,
      print_customer_invoice,
      guest_require_customer_info,
      auto_print_online_customer,
      auto_print_online_kitchen,
    } = updatedSwitchChecked;

    let tokenStr = localStorage.getItem("access_token");
    await axios
      .put(
        `${END_POINT + "/setting"}`,
        {
          bill_cashier: switchCheckedBill,
          bill_qr: switchCheckedBillQr,
          bill_bar: switchCheckedBillBar,
          tem_bar: switchCheckedTemBar,
          tem_cashier: switchCheckedTemCashier,
          order_processing_one: switchCheckedOrderOne,
          order_processing_two: switchCheckedOrderTwo,
          order_processing_three: switchCheckedOrderThree,
          order_processing_four: switchCheckedOrderFour,
          save_provisional_when_print: save_provisional_when_print,
          print_customer_provisional: print_customer_provisional,
          print_customer_invoice: print_customer_invoice,
          guest_require_customer_info: guest_require_customer_info,
          auto_print_online_customer: auto_print_online_customer,
          auto_print_online_kitchen: auto_print_online_kitchen,
          online_print_terminal_id: this.state.onlinePrintTerminalId || null,
          online_print_customer_terminal_id:
            this.state.onlineCustomerTerminalId || null,
          online_print_kitchen_terminal_id:
            this.state.onlineKitchenTerminalId || null,
        },
        { headers: { Authorization: `Bearer ${tokenStr}` } },
      )
      .catch((err) => {
        NotificatioErrController(err.response.data.responseText);
      });
  };

  getPrinterSettingsPayload = (overrides = {}) => ({
    defaultPrinter:
      overrides.defaultPrinter !== undefined
        ? overrides.defaultPrinter
        : localStorage.getItem("defaultPrinter") || "",
    onlineCustomerPrinter:
      overrides.onlineCustomerPrinter !== undefined
        ? overrides.onlineCustomerPrinter
        : localStorage.getItem("onlineCustomerPrinter") || "",
    onlineKitchenPrinter:
      overrides.onlineKitchenPrinter !== undefined
        ? overrides.onlineKitchenPrinter
        : localStorage.getItem("onlineKitchenPrinter") || "",
    customerPaperWidthMm: String(
      normalizePrintPaperWidthMm(
        overrides.customerPaperWidthMm !== undefined
          ? overrides.customerPaperWidthMm
          : this.state.customerPaperWidthMm,
      ),
    ),
    kitchenPaperWidthMm: String(
      normalizePrintPaperWidthMm(
        overrides.kitchenPaperWidthMm !== undefined
          ? overrides.kitchenPaperWidthMm
          : this.state.kitchenPaperWidthMm,
      ),
    ),
  });

  persistPrinterSettings = (overrides = {}) => {
    if (!window.electronAPI?.savePrinterSettings) return Promise.resolve();
    return window.electronAPI.savePrinterSettings(
      this.getPrinterSettingsPayload(overrides),
    );
  };

  handlePrinterChange = (e) => {
    const printer = e.target.value;
    this.setState({ selectedPrinter: printer });
    localStorage.setItem("defaultPrinter", printer);
    localStorage.setItem("default_printer", printer);

    this.persistPrinterSettings({ defaultPrinter: printer }).catch((err) =>
      console.error("Error saving default printer to Electron:", err),
    );

    NotificationManager.success(
      "Đã lưu cấu hình máy in",
      "Thành công",
      3000,
      null,
      null,
      "",
    );
  };

  handleOnlinePrinterChange = (type, printer) => {
    const stateKey =
      type === "customer" ? "onlineCustomerPrinter" : "onlineKitchenPrinter";
    const storageKey =
      type === "customer" ? "onlineCustomerPrinter" : "onlineKitchenPrinter";
    this.setState({ [stateKey]: printer });
    localStorage.setItem(storageKey, printer);

    this.persistPrinterSettings({
      [stateKey]: printer,
    }).catch((err) =>
      console.error("Error saving online printer to Electron:", err),
    );
  };

  handlePaperWidthChange = (type, value) => {
    const normalizedPaperWidth = String(normalizePrintPaperWidthMm(value));
    const stateKey =
      type === "customer" ? "customerPaperWidthMm" : "kitchenPaperWidthMm";

    this.setState({ [stateKey]: normalizedPaperWidth });
    localStorage.setItem(stateKey, normalizedPaperWidth);

    this.persistPrinterSettings({
      [stateKey]: normalizedPaperWidth,
    }).catch((err) =>
      console.error("Error saving printer paper width to Electron:", err),
    );

    NotificationManager.success(
      "Đã lưu khổ giấy in",
      "Thành công",
      3000,
      null,
      null,
      "",
    );
  };


  updateOnlinePrintTerminal = async (documentType, activate) => {
    const {
      terminalId,
      onlineCustomerTerminalId,
      onlineKitchenTerminalId,
    } = this.state;
    if (!terminalId) return;

    const currentTerminalId =
      documentType === "customer"
        ? onlineCustomerTerminalId
        : onlineKitchenTerminalId;
    const nextTerminalId = activate
      ? terminalId
      : currentTerminalId === terminalId
        ? null
        : currentTerminalId || null;
    let nextCustomerTerminalId =
      documentType === "customer"
        ? nextTerminalId
        : onlineCustomerTerminalId || null;
    let nextKitchenTerminalId =
      documentType === "kitchen"
        ? nextTerminalId
        : onlineKitchenTerminalId || null;
    if (!window.electronAPI && activate) {
      if (
        documentType === "customer" &&
        nextKitchenTerminalId === terminalId
      ) {
        nextKitchenTerminalId = null;
      }
      if (
        documentType === "kitchen" &&
        nextCustomerTerminalId === terminalId
      ) {
        nextCustomerTerminalId = null;
      }
    }
    try {
      await this.persistOnlinePrintTerminalIds(
        nextCustomerTerminalId,
        nextKitchenTerminalId,
      );
      this.setState({
        onlinePrintTerminalId: "",
        onlineCustomerTerminalId: nextCustomerTerminalId || "",
        onlineKitchenTerminalId: nextKitchenTerminalId || "",
      });
      NotificationManager.success(
        activate
          ? `Máy này đã nhận ${
              documentType === "customer" ? "hóa đơn khách" : "phiếu bếp/bar"
            }`
          : `Đã tắt ${
              documentType === "customer" ? "hóa đơn khách" : "phiếu bếp/bar"
            } trên máy này`,
        "Thành công",
        3000,
      );
    } catch (error) {
      NotificatioErrController(
        error.response?.data?.responseText || "Không thể cập nhật máy nhận đơn",
      );
    }
  };

  persistOnlinePrintTerminalIds = async (
    customerTerminalId,
    kitchenTerminalId,
  ) => {
    const { switchChecked } = this.state;
    const tokenStr = localStorage.getItem("access_token");
    return axios.put(
      `${END_POINT}/setting`,
      {
        bill_cashier: switchChecked.switchCheckedBill,
        bill_qr: switchChecked.switchCheckedBillQr,
        bill_bar: switchChecked.switchCheckedBillBar,
        tem_bar: switchChecked.switchCheckedTemBar,
        tem_cashier: switchChecked.switchCheckedTemCashier,
        order_processing_one: switchChecked.switchCheckedOrderOne,
        order_processing_two: switchChecked.switchCheckedOrderTwo,
        order_processing_three: switchChecked.switchCheckedOrderThree,
        order_processing_four: switchChecked.switchCheckedOrderFour,
        save_provisional_when_print:
          switchChecked.save_provisional_when_print,
        print_customer_provisional:
          switchChecked.print_customer_provisional,
        print_customer_invoice: switchChecked.print_customer_invoice,
        guest_require_customer_info:
          switchChecked.guest_require_customer_info,
        auto_print_online_customer:
          switchChecked.auto_print_online_customer,
        auto_print_online_kitchen:
          switchChecked.auto_print_online_kitchen,
        online_print_terminal_id: null,
        online_print_customer_terminal_id: customerTerminalId || null,
        online_print_kitchen_terminal_id: kitchenTerminalId || null,
      },
      { headers: { Authorization: `Bearer ${tokenStr}` } },
    );
  };

  testOnlinePrinter = async (type) => {
    const printerName =
      type === "customer"
        ? this.state.onlineCustomerPrinter
        : this.state.onlineKitchenPrinter;
    const paperWidthMm =
      type === "customer"
        ? this.state.customerPaperWidthMm
        : this.state.kitchenPaperWidthMm;
    if (!printerName) {
      NotificatioErrController("Vui lòng chọn máy in trước");
      return;
    }

    const result = await window.electronAPI.printSilent(
      buildSilentPrintHtml(
        `<div id="bill-to-print" data-vmass-print-root style="font-family:Arial;text-align:center">
          <h2>VMASS POS</h2>
          <p>In thử ${type === "customer" ? "hóa đơn khách" : "phiếu bếp/bar"}</p>
          <p>Khổ giấy ${normalizePrintPaperWidthMm(paperWidthMm)}mm</p>
          <p>${new Date().toLocaleString("vi-VN")}</p>
        </div>`,
        { paperWidthMm, documentType: type },
      ),
      printerName,
    );
    if (result?.success) {
      NotificationManager.success("Đã gửi bản in thử", "Thành công", 3000);
    } else {
      NotificatioErrController(result?.error || "Không thể in thử");
    }
  };

  retryFailedOnlinePrintJobs = async () => {
    if (!this.state.terminalId) return;
    const tokenStr = localStorage.getItem("access_token");
    try {
      const response = await axios.post(
        `${END_POINT}/online-print-jobs/retry-failed`,
        {
          terminal_id: this.state.terminalId,
          document_types: window.electronAPI
            ? ["customer", "kitchen"]
            : [this.state.webPrintDocumentType],
        },
        { headers: { Authorization: `Bearer ${tokenStr}` } },
      );
      NotificationManager.success(
        response.data?.responseText || "Đã thử lại các phiếu lỗi",
        "Tự in đơn online",
        3000,
      );
    } catch (error) {
      NotificatioErrController(
        error.response?.data?.responseText || "Không thể thử lại phiếu lỗi",
      );
    }
  };

  changeWebPrintDocumentType = (type) => {
    const normalized = setWebPrintDocumentType(type);
    this.setState({ webPrintDocumentType: normalized });
  };

  runWebKioskPrintTest = () => {
    const frame = document.createElement("iframe");
    frame.style.position = "fixed";
    frame.style.width = "1px";
    frame.style.height = "1px";
    frame.style.opacity = "0";
    frame.style.pointerEvents = "none";
    document.body.appendChild(frame);

    const frameWindow = frame.contentWindow;
    frameWindow.document.open();
    frameWindow.document.write(`
      <!doctype html>
      <html>
        <head><title>VMASS Web Print Test</title></head>
        <body style="font-family:Arial;text-align:center;padding:24px">
          <h2>VMASS POS</h2>
          <p>Web kiosk silent print test</p>
          <p>${new Date().toLocaleString("vi-VN")}</p>
        </body>
      </html>
    `);
    frameWindow.document.close();
    frameWindow.focus();
    frameWindow.print();

    setTimeout(() => {
      frame.remove();
      const confirmed = window.confirm(
        "Bản in thử có tự in mà không xuất hiện hộp thoại in không?",
      );
      const mode = setWebPrintMode(
        confirmed ? "kiosk-silent" : "dialog",
      );
      this.setState({ webPrintMode: mode });
      NotificationManager.success(
        confirmed
          ? "Đã bật chế độ kiosk silent"
          : "Giữ chế độ mở hộp thoại in",
        "Cấu hình web print",
        3000,
      );
    }, 300);
  };

  downloadKioskLauncher = async () => {
    const launcherTerminalId = this.state.terminalId;
    if (!launcherTerminalId) {
      NotificatioErrController("Không xác định được terminal của máy này");
      return;
    }
    const isCustomer = this.state.webPrintDocumentType === "customer";
    const customerTerminalId = isCustomer
      ? launcherTerminalId
      : this.state.onlineCustomerTerminalId || null;
    const kitchenTerminalId = isCustomer
      ? this.state.onlineKitchenTerminalId || null
      : launcherTerminalId;

    try {
      await this.persistOnlinePrintTerminalIds(
        customerTerminalId,
        kitchenTerminalId,
      );
      this.setState({
        onlineCustomerTerminalId: customerTerminalId || "",
        onlineKitchenTerminalId: kitchenTerminalId || "",
      });
    } catch (error) {
      NotificatioErrController(
        error.response?.data?.responseText ||
          "Không thể chỉ định terminal cho launcher",
      );
      return;
    }

    const dashboardUrl = new URL(
      "/app/dashboards/default",
      window.location.origin,
    );
    dashboardUrl.searchParams.set(
      "vmass_print_terminal",
      launcherTerminalId,
    );
    dashboardUrl.searchParams.set(
      "vmass_print_type",
      this.state.webPrintDocumentType,
    );
    downloadWindowsKioskLauncher({
      browser: this.state.kioskBrowser,
      url: dashboardUrl.toString(),
      terminalId: launcherTerminalId,
    });
    NotificationManager.success(
      "Launcher và dashboard này đã dùng chung máy nhận phiếu.",
      "Web kiosk",
      5000,
    );
  };

  renderTerminalAssignmentButton = (documentType) => {
    const label =
      documentType === "customer" ? "hóa đơn khách" : "phiếu bếp/bar";
    const assignedTerminalId =
      documentType === "customer"
        ? this.state.onlineCustomerTerminalId
        : this.state.onlineKitchenTerminalId;
    const isAssignedHere =
      assignedTerminalId && assignedTerminalId === this.state.terminalId;

    return isAssignedHere ? (
      <Button
        size="sm"
        color="danger"
        onClick={() => this.updateOnlinePrintTerminal(documentType, false)}
      >
        Tắt {label} trên máy này
      </Button>
    ) : (
      <Button
        size="sm"
        color="primary"
        onClick={() => this.updateOnlinePrintTerminal(documentType, true)}
      >
        Chỉ định máy này nhận {label}
      </Button>
    );
  };

  onFontSizeChange = (e) => {
    const value = parseInt(e.target.value);
    this.setState({ fontSize: value });
    localStorage.setItem("appFontSize", value);
    document.documentElement.style.setProperty("--app-font-size", `${value}px`);
  };

  onReportTimeChange = async (selectedOptions) => {
    this.setState({ report_time: selectedOptions || [] });

    let tokenStr = localStorage.getItem("access_token");
    const { switchChecked } = this.state;

    const reportTimeStr = (selectedOptions || [])
      .map((opt) => opt.value)
      .join(",");

    await axios
      .put(
        `${END_POINT + "/setting"}`,
        {
          bill_cashier: switchChecked.switchCheckedBill,
          bill_qr: switchChecked.switchCheckedBillQr,
          bill_bar: switchChecked.switchCheckedBillBar,
          tem_bar: switchChecked.switchCheckedTemBar,
          tem_cashier: switchChecked.switchCheckedTemCashier,
          order_processing_one: switchChecked.switchCheckedOrderOne,
          order_processing_two: switchChecked.switchCheckedOrderTwo,
          order_processing_three: switchChecked.switchCheckedOrderThree,
          order_processing_four: switchChecked.switchCheckedOrderFour,
          guest_require_customer_info:
            switchChecked.guest_require_customer_info,
          email_config: this.state.emailConfig,
          report_time: reportTimeStr,
        },
        { headers: { Authorization: `Bearer ${tokenStr}` } },
      )
      .then(() => {
        // Optional: Show success notification
      })
      .catch((err) => {
        NotificatioErrController(err.response?.data?.responseText);
      });
  };

  onShiftRequiredChange = async () => {
    const newValue = !this.state.shift_required;
    this.setState({ shift_required: newValue });

    let tokenStr = localStorage.getItem("access_token");
    await axios
      .put(
        `${END_POINT + "/setting"}`,
        { shift_required: newValue },
        { headers: { Authorization: `Bearer ${tokenStr}` } },
      )
      .catch((err) => {
        // Revert on error
        this.setState({ shift_required: !newValue });
        NotificatioErrController(err.response?.data?.responseText);
      });
  };

  renderGeneralSettings() {
    return (
      <Row>
        <Colxx xxs="12" md="6" className="mb-4">
          <Card className="h-100">
            <CardBody>
              <h5 className="mb-4">
                <i className="simple-icon-screen-desktop mr-2" />
                Giao diện & Hiển thị
              </h5>

              {/* Kiểu hiển thị Menu Sidebar */}
              <div className="mb-4 pb-3 border-bottom">
                <span className="text-muted d-block mb-3 font-weight-bold">
                  Kiểu hiển thị Sidebar Menu
                </span>
                <div className="d-flex align-items-center mb-3 pl-3">
                  <div className="custom-control custom-radio">
                    <input
                      type="radio"
                      id="menuLayoutClassic"
                      name="menuLayoutType"
                      className="custom-control-input"
                      checked={
                        this.props.menuLayoutType === "classic" ||
                        localStorage.getItem("vmass_menu_layout") === "classic"
                      }
                      onChange={() => this.props.setMenuLayoutType("classic")}
                    />
                    <label
                      className="custom-control-label"
                      htmlFor="menuLayoutClassic"
                      style={{ cursor: "pointer" }}
                    >
                      <strong>Menu Cổ điển</strong> (Dạng ô vuông 2 cột truyền thống)
                    </label>
                  </div>
                </div>
                <div className="d-flex align-items-center mb-2 pl-3">
                  <div className="custom-control custom-radio">
                    <input
                      type="radio"
                      id="menuLayoutModern"
                      name="menuLayoutType"
                      className="custom-control-input"
                      checked={
                        this.props.menuLayoutType === "modern-row" ||
                        (!this.props.menuLayoutType &&
                          localStorage.getItem("vmass_menu_layout") !== "classic")
                      }
                      onChange={() => this.props.setMenuLayoutType("modern-row")}
                    />
                    <label
                      className="custom-control-label"
                      htmlFor="menuLayoutModern"
                      style={{ cursor: "pointer" }}
                    >
                      <strong>Menu Hàng ngang Hiện đại</strong> (Dạng hàng ngang thanh lịch, hỗ trợ thu gọn mini icon)
                    </label>
                  </div>
                </div>
              </div>
              <div className="mb-4">
                <span className="text-muted">
                  <IntlMessages id="settings.general.font-size-label" />
                </span>
                <div className="d-flex align-items-center py-3">
                  <span className="mr-3" style={{ minWidth: "40px" }}>
                    <IntlMessages id="settings.general.font-size-small" />
                  </span>
                  <input
                    type="range"
                    min="12"
                    max="20"
                    step="1"
                    value={this.state.fontSize}
                    onChange={this.onFontSizeChange}
                    style={{ width: "200px", cursor: "pointer" }}
                  />
                  <span className="ml-3" style={{ minWidth: "40px" }}>
                    <IntlMessages id="settings.general.font-size-large" />
                  </span>
                  <span
                    className="ml-4 badge badge-primary"
                    style={{ fontSize: "14px", padding: "5px 10px" }}
                  >
                    {this.state.fontSize}px
                  </span>
                </div>
                <div>
                  <p
                    className="text-muted mb-0"
                    style={{ fontSize: `${this.state.fontSize}px` }}
                  >
                    <IntlMessages
                      id="settings.general.preview-text"
                      values={{ size: this.state.fontSize }}
                    />
                  </p>
                </div>
              </div>
            </CardBody>
          </Card>
        </Colxx>

        <Colxx xxs="12" md="6" className="mb-4">
          <Card className="h-100">
            <CardBody>
              <h5 className="mb-4">
                <i className="simple-icon-chart mr-2" />
                <IntlMessages id="settings.general.report-title" />
              </h5>
              <div className="mb-4">
                <span className="text-muted">
                  <IntlMessages id="settings.general.daily-report-time" />
                </span>
                <div className="py-3">
                  <Select
                    className="react-select"
                    classNamePrefix="react-select"
                    isMulti
                    name="report_time"
                    value={this.state.report_time}
                    onChange={this.onReportTimeChange}
                    options={this.reportTimeOptions}
                    placeholder={this.props.intl.formatMessage({
                      id: "settings.general.select-time-placeholder",
                    })}
                    style={{ minWidth: "300px" }}
                  />
                  <span className="text-muted mt-2 d-inline-block">
                    <IntlMessages id="settings.general.report-note" />
                  </span>
                </div>
              </div>
            </CardBody>
          </Card>
        </Colxx>

        <Colxx xxs="12" md="6" className="mb-4">
          <Card className="h-100">
            <CardBody>
              <h5 className="mb-4">
                <i className="iconsminds-clock-forward mr-2" />
                Quản lý ca làm việc
              </h5>
              <div className="d-flex align-items-center pl-4 pb-3 pt-3">
                <Switch
                  className="custom-switch custom-switch-primary custom-switch-small mr-2"
                  checked={this.state.shift_required}
                  onChange={this.onShiftRequiredChange}
                />
                <span className="mr-2">
                  Bắt buộc mở ca trước khi bán hàng
                </span>
              </div>
              <span className="text-muted pl-4">
                Khi bật, nhân viên phải mở ca trước khi tạo đơn hàng. Giúp đối soát tiền mặt cuối ca chính xác hơn.
              </span>
            </CardBody>
          </Card>
        </Colxx>
      </Row>
    );
  }

  renderInvoiceSettings() {
    const { switchChecked } = this.state;
    return (
      <Row>
        <Colxx xxs="12" md="6" className="mb-4">
          <Card className="h-100">
            <CardBody>
              <h5 className="mb-4">
                <i className="iconsminds-printer mr-2" />
                <IntlMessages id="settings.invoice.title" />
              </h5>

              <div className="mb-4">
                <span className="text-muted">
                  <IntlMessages id="settings.invoice.section-1" />
                </span>
                <div className="d-flex align-items-center pl-4 pb-3 pt-3">
                  <Switch
                    className="custom-switch custom-switch-primary custom-switch-small mr-2"
                    checked={switchChecked.switchCheckedBill}
                    onChange={() => this.onChange("switchCheckedBill")}
                  />
                  <span className="mr-2">
                    <IntlMessages id="settings.invoice.print-at-counter" />
                  </span>
                </div>
              </div>

              <div className="mb-4">
                <span className="text-muted mr-2">
                  <IntlMessages id="settings.invoice.section-2" />
                </span>
                <div className="d-flex align-items-center pl-4 pb-3 pt-3">
                  <Switch
                    className="custom-switch custom-switch-primary custom-switch-small mr-2"
                    checked={switchChecked.switchCheckedBillQr}
                    onChange={() => this.onChange("switchCheckedBillQr")}
                  />
                  <span className="mr-2">
                    <IntlMessages id="settings.invoice.print-kitchen" />
                  </span>
                </div>
              </div>

              <div className="mb-4">
                <span className="text-muted">
                  <IntlMessages id="settings.invoice.section-3" />
                </span>
                <div className="d-flex align-items-center pl-4 pb-3 pt-3">
                  <Switch
                    className="custom-switch custom-switch-primary custom-switch-small mr-2"
                    checked={switchChecked.switchCheckedOrderOne}
                    onChange={() => this.onChange("switchCheckedOrderOne")}
                  />
                  <span className="mr-2">
                    <IntlMessages id="settings.invoice.process-1" />
                  </span>
                </div>
                <div className="d-flex align-items-center pl-4 pb-3">
                  <Switch
                    className="custom-switch custom-switch-primary custom-switch-small mr-2"
                    checked={switchChecked.switchCheckedOrderTwo}
                    onChange={() => this.onChange("switchCheckedOrderTwo")}
                  />
                  <span className="mr-2">
                    <IntlMessages id="settings.invoice.process-2" />
                  </span>
                </div>
                <div className="d-flex align-items-center pl-4 pb-3">
                  <Switch
                    className="custom-switch custom-switch-primary custom-switch-small mr-2"
                    checked={switchChecked.switchCheckedOrderThree}
                    onChange={() => this.onChange("switchCheckedOrderThree")}
                  />
                  <span className="mr-2">
                    <IntlMessages id="settings.invoice.process-3" />
                  </span>
                </div>
                <div className="d-flex align-items-center pl-4 pb-3">
                  <Switch
                    className="custom-switch custom-switch-primary custom-switch-small mr-2"
                    checked={switchChecked.switchCheckedOrderFour}
                    onChange={() => this.onChange("switchCheckedOrderFour")}
                  />
                  <span className="mr-2">
                    <IntlMessages id="settings.invoice.process-4" />
                  </span>
                </div>
              </div>

              <div className="mb-4">
                <span className="text-muted">In ấn hóa đơn</span>
                <div className="d-flex align-items-center pl-4 pb-3 pt-3">
                  <Switch
                    className="custom-switch custom-switch-primary custom-switch-small mr-2"
                    checked={switchChecked.save_provisional_when_print}
                    onChange={() => this.onChange("save_provisional_when_print")}
                  />
                  <span className="mr-2">Lưu hóa đơn tạm tính khi bấm In tạm tính</span>
                </div>
                <div className="d-flex align-items-center pl-4 pb-3">
                  <Switch
                    className="custom-switch custom-switch-primary custom-switch-small mr-2"
                    checked={switchChecked.print_customer_provisional}
                    onChange={() => this.onChange("print_customer_provisional")}
                  />
                  <span className="mr-2">In thông tin khách hàng khi In tạm tính</span>
                </div>
                <div className="d-flex align-items-center pl-4 pb-3">
                  <Switch
                    className="custom-switch custom-switch-primary custom-switch-small mr-2"
                    checked={switchChecked.print_customer_invoice}
                    onChange={() => this.onChange("print_customer_invoice")}
                  />
                  <span className="mr-2">In thông tin khách hàng khi bấm Hoàn tất thanh toán và in hóa đơn</span>
                </div>
              </div>

              <div className="mb-4">
                <span className="text-muted">Đặt món từ khách</span>
                <div className="d-flex align-items-center pl-4 pb-3 pt-3">
                  <Switch
                    className="custom-switch custom-switch-primary custom-switch-small mr-2"
                    checked={switchChecked.guest_require_customer_info}
                    onChange={() =>
                      this.onChange("guest_require_customer_info")
                    }
                  />
                  <span className="mr-2">
                    Bắt buộc khách nhập đầy đủ tên và số điện thoại khi đặt món
                  </span>
                </div>
              </div>

              <div className="mb-4">
                <span className="text-muted">Tự in đơn từ Menu Online</span>
                <div className="d-flex align-items-center pl-4 pb-3 pt-3">
                  <Switch
                    className="custom-switch custom-switch-primary custom-switch-small mr-2"
                    checked={switchChecked.auto_print_online_customer}
                    onChange={() =>
                      this.onChange("auto_print_online_customer")
                    }
                  />
                  <span className="mr-2">Tự in hóa đơn khách</span>
                </div>
                <div className="d-flex align-items-center pl-4 pb-3">
                  <Switch
                    className="custom-switch custom-switch-primary custom-switch-small mr-2"
                    checked={switchChecked.auto_print_online_kitchen}
                    onChange={() =>
                      this.onChange("auto_print_online_kitchen")
                    }
                  />
                  <span className="mr-2">Tự in phiếu bếp/bar</span>
                </div>
              </div>

              <div className="mb-4">
                <span className="text-muted">
                  <IntlMessages id="settings.invoice.process-4-title" />
                </span>
                <div className="d-flex align-items-center pl-4 py-3">
                  <Switch
                    className="custom-switch custom-switch-primary custom-switch-small mr-2"
                    checked={true}
                    disabled
                  />
                  <span className="mr-2">
                    <IntlMessages id="settings.invoice.process-4-flow" />
                  </span>
                </div>
              </div>
            </CardBody>
          </Card>
        </Colxx>

        <Colxx xxs="12" md="6" className="mb-4">
          <Card className="h-100">
            <CardBody>
              <h5 className="mb-4">
                <i className="simple-icon-settings mr-2" />
                Cấu hình máy in (Silent Print)
              </h5>
              <div className="mb-4">
                {window.electronAPI ? (
                  <>
                    <div className="d-flex align-items-center pl-4 pt-3">
                      <span className="mr-3">Chọn máy in mặc định:</span>
                      <Input
                        type="select"
                        style={{ maxWidth: "350px" }}
                        value={this.state.selectedPrinter}
                        onChange={this.handlePrinterChange}
                      >
                        <option value="">
                          -- Dùng máy in mặc định của Windows --
                        </option>
                        {this.state.printers.map((p) => (
                          <option key={p.name} value={p.name}>
                            {p.name}
                          </option>
                        ))}
                      </Input>
                    </div>
                    <small className="text-muted pl-4 d-block mt-2">
                      *Chọn máy in để in hóa đơn ngay lập tức khi thanh toán.
                    </small>

                    <hr />
                    <div className="pl-4">
                      <strong className="d-block mb-3">
                        Phân công nhận đơn online
                      </strong>
                      <div className="mb-2">
                        {this.renderTerminalAssignmentButton("customer")}
                      </div>
                      <div className="mb-3">
                        {this.renderTerminalAssignmentButton("kitchen")}
                      </div>
                      <Button
                        size="sm"
                        outline
                        color="primary"
                        className="mb-3"
                        onClick={this.retryFailedOnlinePrintJobs}
                      >
                        Thử lại phiếu lỗi
                      </Button>
                      <small className="text-muted d-block mb-3">
                        Mỗi loại phiếu chỉ có một máy nhận. Có thể phân công hóa
                        đơn khách và phiếu bếp/bar cho hai máy khác nhau.
                      </small>
                      {((this.state.onlineCustomerTerminalId ===
                        this.state.terminalId &&
                        switchChecked.auto_print_online_customer &&
                        !this.state.onlineCustomerPrinter) ||
                        (this.state.onlineKitchenTerminalId ===
                          this.state.terminalId &&
                          switchChecked.auto_print_online_kitchen &&
                          !this.state.onlineKitchenPrinter)) ? (
                        <Alert color="warning">
                          Máy này đang nhận đơn nhưng còn loại phiếu chưa được
                          chọn máy in.
                        </Alert>
                      ) : null}

                      <FormGroup>
                        <Label>Máy in hóa đơn khách</Label>
                        <div className="d-flex">
                          <Input
                            type="select"
                            value={this.state.onlineCustomerPrinter}
                            onChange={(e) =>
                              this.handleOnlinePrinterChange(
                                "customer",
                                e.target.value,
                              )
                            }
                          >
                            <option value="">-- Chọn máy in --</option>
                            {this.state.printers.map((p) => (
                              <option key={`customer-${p.name}`} value={p.name}>
                                {p.name}
                              </option>
                            ))}
                          </Input>
                          <Button
                            className="ml-2"
                            outline
                            color="primary"
                            onClick={() => this.testOnlinePrinter("customer")}
                          >
                            In thử
                          </Button>
                        </div>
                        <div className="d-flex align-items-center mt-2">
                          <Label className="mb-0 mr-2">Khổ giấy</Label>
                          <Input
                            type="select"
                            style={{ maxWidth: "140px" }}
                            value={this.state.customerPaperWidthMm}
                            onChange={(e) =>
                              this.handlePaperWidthChange(
                                "customer",
                                e.target.value,
                              )
                            }
                          >
                            <option value="80">80mm</option>
                            <option value="58">58mm</option>
                          </Input>
                        </div>
                      </FormGroup>

                      <FormGroup>
                        <Label>Máy in phiếu bếp/bar</Label>
                        <div className="d-flex">
                          <Input
                            type="select"
                            value={this.state.onlineKitchenPrinter}
                            onChange={(e) =>
                              this.handleOnlinePrinterChange(
                                "kitchen",
                                e.target.value,
                              )
                            }
                          >
                            <option value="">-- Chọn máy in --</option>
                            {this.state.printers.map((p) => (
                              <option key={`kitchen-${p.name}`} value={p.name}>
                                {p.name}
                              </option>
                            ))}
                          </Input>
                          <Button
                            className="ml-2"
                            outline
                            color="primary"
                            onClick={() => this.testOnlinePrinter("kitchen")}
                          >
                            In thử
                          </Button>
                        </div>
                        <div className="d-flex align-items-center mt-2">
                          <Label className="mb-0 mr-2">Khổ giấy</Label>
                          <Input
                            type="select"
                            style={{ maxWidth: "140px" }}
                            value={this.state.kitchenPaperWidthMm}
                            onChange={(e) =>
                              this.handlePaperWidthChange(
                                "kitchen",
                                e.target.value,
                              )
                            }
                          >
                            <option value="80">80mm</option>
                            <option value="58">58mm</option>
                          </Input>
                        </div>
                      </FormGroup>
                    </div>
                  </>
                ) : (
                  <div className="pl-4 pt-3">
                    <h6>Web kiosk printing</h6>
                    <p className="text-muted">
                      Web dùng máy in mặc định của Windows. Nếu chưa xác nhận
                      kiosk, mỗi đơn sẽ tự mở hộp thoại in.
                    </p>

                    <FormGroup>
                      <Label>Loại phiếu máy web này nhận</Label>
                      <Input
                        type="select"
                        value={this.state.webPrintDocumentType}
                        onChange={(e) =>
                          this.changeWebPrintDocumentType(e.target.value)
                        }
                      >
                        <option value="customer">Hóa đơn khách</option>
                        <option value="kitchen">Phiếu bếp/bar</option>
                      </Input>
                    </FormGroup>

                    <div className="mb-3">
                      {this.renderTerminalAssignmentButton(
                        this.state.webPrintDocumentType,
                      )}
                    </div>

                    <Alert
                      color={
                        this.state.webPrintMode === "kiosk-silent"
                          ? "success"
                          : "warning"
                      }
                    >
                      Chế độ hiện tại:{" "}
                      <strong>
                        {this.state.webPrintMode === "kiosk-silent"
                          ? "Kiosk silent"
                          : "Mở hộp thoại in"}
                      </strong>
                    </Alert>

                    <Button
                      color="primary"
                      outline
                      className="mr-2 mb-3"
                      onClick={this.runWebKioskPrintTest}
                    >
                      In thử và xác nhận kiosk
                    </Button>
                    <Button
                      color="secondary"
                      outline
                      className="mb-3"
                      onClick={() => {
                        setWebPrintMode("dialog");
                        this.setState({ webPrintMode: "dialog" });
                      }}
                    >
                      Dùng hộp thoại in
                    </Button>

                    <hr />
                    <FormGroup>
                      <Label>Trình duyệt launcher Windows</Label>
                      <Input
                        type="select"
                        value={this.state.kioskBrowser}
                        onChange={(e) =>
                          this.setState({ kioskBrowser: e.target.value })
                        }
                      >
                        <option value="edge">Microsoft Edge</option>
                        <option value="chrome">Google Chrome</option>
                      </Input>
                    </FormGroup>
                    <Button
                      color="primary"
                      onClick={this.downloadKioskLauncher}
                    >
                      Tải launcher kiosk Windows
                    </Button>
                    <small className="text-muted d-block mt-2">
                      Chạy file .cmd vừa tải, đăng nhập VMASS trong cửa sổ mới,
                      đặt máy in mặc định rồi thực hiện bước In thử. Khi tắt
                      launcher, giữ dashboard thường đang mở để nhận phiếu bằng
                      hộp thoại in.
                    </small>
                  </div>
                )}
              </div>
            </CardBody>
          </Card>
        </Colxx>
      </Row>
    );
  }

  renderSocialSettings() {
    const {
      facebookPages,
      zaloOAs,
      loadingSocial,
      socialError,
      socialSuccess,
    } = this.state;

    return (
      <div>
        {socialError && (
          <Alert color="danger" className="mb-3">
            {socialError}
            <button
              className="close"
              onClick={() => this.setState({ socialError: null })}
            >
              ×
            </button>
          </Alert>
        )}
        {socialSuccess && (
          <Alert color="success" className="mb-3">
            {socialSuccess}
            <button
              className="close"
              onClick={() => this.setState({ socialSuccess: null })}
            >
              ×
            </button>
          </Alert>
        )}

        {/* Facebook Section */}
        <Card className="mb-4">
          <CardBody>
            <div className="d-flex justify-content-between align-items-start mb-3">
              <h5 className="mb-0">
                <i
                  className="iconsminds-facebook mr-2"
                  style={{ color: "#1877f2" }}
                />
                <IntlMessages id="facebook.settings-title" />
              </h5>
              <span
                id="facebookGuide"
                className="text-primary"
                style={{ cursor: "pointer", fontSize: "13px" }}
                onClick={() =>
                  this.setState((prev) => ({
                    facebookGuideOpen: !prev.facebookGuideOpen,
                  }))
                }
              >
                <i className="simple-icon-question mr-1" />
                <IntlMessages id="facebook.guide" />
              </span>
              <Popover
                placement="bottom-end"
                isOpen={this.state.facebookGuideOpen}
                target="facebookGuide"
                toggle={() =>
                  this.setState((prev) => ({
                    facebookGuideOpen: !prev.facebookGuideOpen,
                  }))
                }
              >
                <PopoverBody>
                  <strong>
                    <IntlMessages id="facebook.how-to-connect" />
                  </strong>
                  <ol className="pl-3 mb-0 mt-2" style={{ fontSize: "13px" }}>
                    <li>
                      <IntlMessages id="facebook.guide-step-1" />
                    </li>
                    <li>
                      <IntlMessages id="facebook.guide-step-2" />
                    </li>
                    <li>
                      <IntlMessages id="facebook.guide-step-3" />
                    </li>
                    <li>
                      <IntlMessages id="facebook.guide-step-4" />
                    </li>
                    <li>
                      <IntlMessages id="facebook.guide-step-5" />
                    </li>
                  </ol>
                </PopoverBody>
              </Popover>
            </div>
            <p className="text-muted mb-3">
              <IntlMessages id="facebook.description" />
            </p>

            {/* Developer instructions */}
            {/* <Card className="bg-light mb-3">
              <CardBody className="p-3">
                <h6 className="mb-2">
                  <i className="simple-icon-info mr-2" />
                  Cấu hình Webhook (Dành cho Kỹ thuật):
                </h6>
                <ol className="mb-0 pl-3" style={{ fontSize: "13px" }}>
                  <li className="mb-1">
                    <strong>Callback URL:</strong>{" "}
                    <span className="text-primary">
                      {END_POINT}/api/facebook/webhook
                    </span>
                  </li>
                  <li className="mb-1">
                    <strong>Verify Token:</strong>{" "}
                    <span className="text-danger">FB_VERIFY_TOKEN trong .env</span>
                  </li>
                  <li className="mb-1">
                    <strong>Fields:</strong> messages, messaging_postbacks
                  </li>
                </ol>
              </CardBody>
            </Card>
            <Card className="bg-light mb-3">
              <CardBody className="p-3">
                <h6 className="mb-2">
                  <i className="simple-icon-shield mr-2" />
                  Quyền truy cập yêu cầu:
                </h6>
                <ul
                  className="mb-0 pl-3 text-muted"
                  style={{ fontSize: "12px" }}
                >
                  <li>pages_show_list (Xem danh sách trang)</li>
                  <li>pages_messaging (Gửi/nhận tin nhắn)</li>
                  <li>pages_read_engagement (Xem tương tác)</li>
                  <li>pages_manage_posts (Đăng bài viết)</li>
                  <li>pages_manage_metadata (Quản lý thông tin trang)</li>
                </ul>
              </CardBody>
            </Card> */}

            {
              /* Permission Check for Facebook */
              !this.checkPermission("pro") ? (
                <div className="mb-4">
                  <Alert color="warning">
                    <IntlMessages id="facebook.upgrade-warning" />{" "}
                    <a
                      href="/app/applications/upgrade"
                      className="alert-link font-weight-bold"
                    >
                      <IntlMessages id="facebook.upgrade-now" />
                    </a>
                  </Alert>
                  <Button color="secondary" disabled className="mb-4">
                    <i className="simple-icon-lock mr-2" />
                    <IntlMessages id="facebook.connect-new-locked" />
                  </Button>
                </div>
              ) : (
                <>
                <div className="d-flex align-items-center mb-4" style={{ gap: "8px" }}>
                  <Button
                    color="primary"
                    onClick={this.handleConnectFacebook}
                  >
                    <i className="simple-icon-plus mr-2" />
                    <IntlMessages id="facebook.connect-new" />
                  </Button>
                  <Button
                    color="outline-secondary"
                    onClick={() =>
                      this.setState((prev) => ({
                        showManualToken: !prev.showManualToken,
                        manualToken: "",
                        socialError: null,
                      }))
                    }
                  >
                    <i className="simple-icon-key mr-2" />
                    <IntlMessages id="facebook.manual.btn" />
                  </Button>
                </div>

                {/* Manual Token Form */}
                {this.state.showManualToken && (
                  <Card className="mb-4 border" style={{ borderColor: "#e0e0e0" }}>
                    <CardBody className="p-3">
                      <div className="d-flex justify-content-between align-items-start mb-2">
                        <h6 className="mb-0">
                          <i className="simple-icon-key mr-2" style={{ color: "#1877f2" }} />
                          <IntlMessages id="facebook.manual.title" />
                        </h6>
                        <span
                          id="manualTokenGuide"
                          className="text-primary"
                          style={{ cursor: "pointer", fontSize: "13px" }}
                          onClick={() =>
                            this.setState((prev) => ({
                              manualTokenGuideOpen: !prev.manualTokenGuideOpen,
                            }))
                          }
                        >
                          <i className="simple-icon-question mr-1" />
                          <IntlMessages id="facebook.manual.guide" />
                        </span>
                        <Popover
                          placement="bottom-end"
                          isOpen={this.state.manualTokenGuideOpen}
                          target="manualTokenGuide"
                          toggle={() =>
                            this.setState((prev) => ({
                              manualTokenGuideOpen: !prev.manualTokenGuideOpen,
                            }))
                          }
                        >
                          <PopoverBody>
                            <strong>
                              <IntlMessages id="facebook.manual.guide-title" />
                            </strong>
                            <ol className="pl-3 mb-0 mt-2" style={{ fontSize: "13px" }}>
                              <li>
                                <IntlMessages id="facebook.manual.guide-step-1" />
                              </li>
                              <li>
                                <IntlMessages id="facebook.manual.guide-step-2" />
                              </li>
                              <li>
                                <IntlMessages id="facebook.manual.guide-step-3" />
                              </li>
                              <li>
                                <IntlMessages id="facebook.manual.guide-step-4" />
                              </li>
                            </ol>
                            <div className="mt-2" style={{ fontSize: "12px" }}>
                              <a
                                href="https://developers.facebook.com/tools/explorer/"
                                target="_blank"
                                rel="noopener noreferrer"
                                className="text-primary"
                              >
                                <i className="simple-icon-link mr-1" />
                                Facebook Graph API Explorer
                              </a>
                            </div>
                          </PopoverBody>
                        </Popover>
                      </div>
                      <p className="text-muted mb-2" style={{ fontSize: "13px" }}>
                        <IntlMessages id="facebook.manual.desc" />
                      </p>

                      {/* Step 1: Token Input + Preview Button */}
                      <div className="d-flex" style={{ gap: "8px" }}>
                        <Input
                          type="textarea"
                          rows="2"
                          placeholder={this.props.intl.formatMessage({
                            id: "facebook.manual.placeholder",
                          })}
                          value={this.state.manualToken}
                          onChange={(e) =>
                            this.setState({
                              manualToken: e.target.value,
                              previewPages: [],
                              selectedPageIds: new Set(),
                              previewTokenType: null,
                            })
                          }
                          style={{ flex: 1, fontSize: "13px", fontFamily: "monospace" }}
                          disabled={this.state.previewLoading}
                        />
                        <Button
                          color="info"
                          onClick={this.handlePreviewPages}
                          disabled={this.state.previewLoading || !this.state.manualToken.trim()}
                          style={{ minWidth: "120px", alignSelf: "flex-end" }}
                        >
                          {this.state.previewLoading ? (
                            <span>
                              <i className="simple-icon-refresh mr-1" />
                              <IntlMessages id="facebook.manual.checking" />
                            </span>
                          ) : (
                            <span>
                              <i className="simple-icon-magnifier mr-1" />
                              <IntlMessages id="facebook.manual.check-btn" />
                            </span>
                          )}
                        </Button>
                      </div>

                      {/* Step 2: Page Selection List */}
                      {this.state.previewPages.length > 0 && (
                        <div className="mt-3">
                          <div className="d-flex justify-content-between align-items-center mb-2">
                            <h6 className="mb-0" style={{ fontSize: "13px" }}>
                              <i className="simple-icon-list mr-1" />
                              <IntlMessages id="facebook.manual.select-pages" />
                              <span className="badge badge-primary ml-2">
                                {this.state.previewPages.length}
                              </span>
                            </h6>
                            {this.state.previewPages.length > 1 && (
                              <Button
                                color="link"
                                size="xs"
                                onClick={this.toggleSelectAll}
                                style={{ fontSize: "12px" }}
                              >
                                {this.state.selectedPageIds.size === this.state.previewPages.length
                                  ? this.props.intl.formatMessage({ id: "facebook.manual.deselect-all" })
                                  : this.props.intl.formatMessage({ id: "facebook.manual.select-all" })}
                              </Button>
                            )}
                          </div>

                          <div
                            style={{
                              maxHeight: "250px",
                              overflowY: "auto",
                              border: "1px solid #e9ecef",
                              borderRadius: "6px",
                            }}
                          >
                            {this.state.previewPages.map((page) => (
                              <div
                                key={page.page_id}
                                className="d-flex align-items-center p-2 border-bottom"
                                style={{
                                  cursor: "pointer",
                                  backgroundColor: this.state.selectedPageIds.has(page.page_id)
                                    ? "#e8f4fd"
                                    : "transparent",
                                  transition: "background-color 0.15s",
                                }}
                                onClick={() => this.togglePageSelection(page.page_id)}
                              >
                                <input
                                  type="checkbox"
                                  checked={this.state.selectedPageIds.has(page.page_id)}
                                  onChange={() => {}}
                                  className="mr-3"
                                  style={{ width: 18, height: 18, cursor: "pointer" }}
                                />
                                {page.page_picture ? (
                                  <img
                                    src={page.page_picture}
                                    alt={page.page_name}
                                    className="rounded-circle mr-2"
                                    style={{ width: 36, height: 36, objectFit: "cover" }}
                                    onError={(e) => {
                                      e.target.src = "https://ui-avatars.com/api/?name=" +
                                        encodeURIComponent(page.page_name.charAt(0)) +
                                        "&background=1877f2&color=fff";
                                    }}
                                  />
                                ) : (
                                  <div
                                    className="rounded-circle mr-2 d-flex align-items-center justify-content-center"
                                    style={{
                                      width: 36,
                                      height: 36,
                                      backgroundColor: "#1877f2",
                                      color: "#fff",
                                      fontSize: 14,
                                      fontWeight: "bold",
                                    }}
                                  >
                                    {page.page_name.charAt(0).toUpperCase()}
                                  </div>
                                )}
                                <div className="flex-grow-1">
                                  <div style={{ fontSize: "13px", fontWeight: 500 }}>
                                    {page.page_name}
                                  </div>
                                  <small className="text-muted">ID: {page.page_id}</small>
                                </div>
                              </div>
                            ))}
                          </div>

                          {/* Connect selected pages */}
                          <div className="mt-3 d-flex align-items-center" style={{ gap: "8px" }}>
                            <Button
                              color="success"
                              onClick={this.handleConnectSelectedPages}
                              disabled={this.state.connectingManualToken || this.state.selectedPageIds.size === 0}
                            >
                              {this.state.connectingManualToken ? (
                                <span>
                                  <i className="simple-icon-refresh mr-1" />
                                  <IntlMessages id="facebook.manual.connecting" />
                                </span>
                              ) : (
                                <span>
                                  <i className="simple-icon-check mr-1" />
                                  <IntlMessages id="facebook.manual.connect-btn" />
                                  {this.state.selectedPageIds.size > 0 && (
                                    <span className="ml-1">({this.state.selectedPageIds.size})</span>
                                  )}
                                </span>
                              )}
                            </Button>
                            <span className="text-muted" style={{ fontSize: "12px" }}>
                              {this.state.selectedPageIds.size} / {this.state.previewPages.length}{" "}
                              {this.props.intl.formatMessage({ id: "facebook.manual.pages-selected" })}
                            </span>
                          </div>
                        </div>
                      )}
                    </CardBody>
                  </Card>
                )}
                </>
              )
            }

            {loadingSocial ? (
              <p className="text-muted">
                <IntlMessages id="facebook.loading" />
              </p>
            ) : facebookPages.length === 0 ? (
              <p className="text-muted">
                <IntlMessages id="facebook.no-pages" />
              </p>
            ) : (
              <div className="table-responsive">
                <table className="table table-hover">
                  <thead>
                    <tr>
                      <th style={{ width: "60px" }}></th>
                      <th>
                        <IntlMessages id="facebook.page-name" />
                      </th>
                      <th>
                        <IntlMessages id="facebook.page-id" />
                      </th>
                      <th>
                        <IntlMessages id="facebook.connected-date" />
                      </th>
                      <th style={{ width: "120px" }}>
                        <IntlMessages id="facebook.action" />
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {facebookPages.map((page) => (
                      <tr key={page.id}>
                        <td>
                          {page.page_picture ? (
                            <img
                              src={page.page_picture}
                              alt={page.page_name}
                              className="rounded-circle"
                              style={{ width: 40, height: 40 }}
                            />
                          ) : (
                            <div
                              className="rounded-circle bg-primary d-flex align-items-center justify-content-center"
                              style={{ width: 40, height: 40 }}
                            >
                              <i className="iconsminds-facebook text-white" />
                            </div>
                          )}
                        </td>
                        <td>
                          <strong>{page.page_name}</strong>
                        </td>
                        <td>
                          <code>{page.page_id}</code>
                        </td>
                        <td>
                          {new Date(page.createdAt).toLocaleDateString("vi-VN")}
                        </td>
                        <td>
                          <Button
                            color="danger"
                            size="xs"
                            className="mr-2"
                            onClick={() =>
                              this.handleDisconnectFacebook(page.page_id)
                            }
                            title={this.props.intl.formatMessage({
                              id: "facebook.disconnect",
                            })}
                          >
                            <i className="simple-icon-close" />
                          </Button>
                          <a
                            href="/app/pages/message"
                            className="btn btn-info btn-xs"
                            title={this.props.intl.formatMessage({
                              id: "facebook.go-to-messenger",
                            })}
                          >
                            <i className="simple-icon-bubble" />
                          </a>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            )}
          </CardBody>
        </Card>

        {/* Zalo Section */}
        <Card className="mb-4">
          <CardBody>
            <div className="d-flex justify-content-between align-items-start mb-3">
              <h5 className="mb-0">
                <i
                  className="simple-icon-bubble mr-2"
                  style={{ color: "#0068ff" }}
                />
                <IntlMessages id="settings.zalo.title" />
              </h5>
              <span
                id="zaloGuide"
                className="text-primary"
                style={{ cursor: "pointer", fontSize: "13px" }}
                onClick={() =>
                  this.setState((prev) => ({
                    zaloGuideOpen: !prev.zaloGuideOpen,
                  }))
                }
              >
                <i className="simple-icon-question mr-1" />
                <IntlMessages id="settings.zalo.guide" />
              </span>
              <Popover
                placement="bottom-end"
                isOpen={this.state.zaloGuideOpen}
                target="zaloGuide"
                toggle={() =>
                  this.setState((prev) => ({
                    zaloGuideOpen: !prev.zaloGuideOpen,
                  }))
                }
              >
                <PopoverBody>
                  <strong>
                    <IntlMessages id="settings.zalo.guide.title" />
                  </strong>
                  <ol className="pl-3 mb-0 mt-2" style={{ fontSize: "13px" }}>
                    <li>
                      <IntlMessages id="settings.zalo.guide.step1" />
                    </li>
                    <li>
                      <IntlMessages id="settings.zalo.guide.step2" />
                    </li>
                    <li>
                      <IntlMessages id="settings.zalo.guide.step3" />
                    </li>
                    <li>
                      <IntlMessages id="settings.zalo.guide.step4" />
                    </li>
                    <li>
                      <IntlMessages id="settings.zalo.guide.step5" />
                    </li>
                  </ol>
                </PopoverBody>
              </Popover>
            </div>
            <p className="text-muted mb-3">
              <IntlMessages id="settings.zalo.desc" />
            </p>

            {
              /* Permission Check for Zalo */
              !this.checkPermission("pro") ? (
                <div className="mb-4">
                  <Alert color="warning">
                    <IntlMessages id="settings.zalo.upgrade-warning" />{" "}
                    <a
                      href="/app/applications/upgrade"
                      className="alert-link font-weight-bold"
                    >
                      <IntlMessages id="settings.zalo.upgrade-btn" />
                    </a>
                  </Alert>
                  <Button color="secondary" disabled className="mb-4">
                    <i className="simple-icon-lock mr-2" />
                    <IntlMessages id="settings.zalo.connect-locked" />
                  </Button>
                </div>
              ) : (
                <Button
                  style={{ backgroundColor: "#0068ff", borderColor: "#0068ff" }}
                  onClick={this.handleConnectZalo}
                  className="mb-4"
                >
                  <i className="simple-icon-plus mr-2" />
                  <IntlMessages id="settings.zalo.connect-btn" />
                </Button>
              )
            }

            {loadingSocial ? (
              <p className="text-muted">
                <IntlMessages id="settings.zalo.loading" />
              </p>
            ) : zaloOAs.length === 0 ? (
              <p className="text-muted">
                <IntlMessages id="settings.zalo.no-oa" />
              </p>
            ) : (
              <div className="table-responsive">
                <table className="table table-hover">
                  <thead>
                    <tr>
                      <th style={{ width: "60px" }}></th>
                      <th>
                        <IntlMessages id="settings.zalo.table.name" />
                      </th>
                      <th>
                        <IntlMessages id="settings.zalo.table.id" />
                      </th>
                      <th>
                        <IntlMessages id="settings.zalo.table.date" />
                      </th>
                      <th style={{ width: "120px" }}>
                        <IntlMessages id="settings.zalo.table.action" />
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {zaloOAs.map((oa) => (
                      <tr key={oa.id}>
                        <td>
                          {oa.oa_avatar ? (
                            <img
                              src={oa.oa_avatar}
                              alt={oa.oa_name}
                              className="rounded-circle"
                              style={{ width: 40, height: 40 }}
                            />
                          ) : (
                            <div
                              className="rounded-circle d-flex align-items-center justify-content-center"
                              style={{
                                width: 40,
                                height: 40,
                                backgroundColor: "#0068ff",
                              }}
                            >
                              <span className="text-white font-weight-bold">
                                Z
                              </span>
                            </div>
                          )}
                        </td>
                        <td>
                          <strong>{oa.oa_name}</strong>
                        </td>
                        <td>
                          <code>{oa.oa_id}</code>
                        </td>
                        <td>
                          {new Date(oa.createdAt).toLocaleDateString("vi-VN")}
                        </td>
                        <td>
                          <Button
                            color="danger"
                            size="sm"
                            onClick={() => this.handleDisconnectZalo(oa.oa_id)}
                          >
                            <IntlMessages id="settings.zalo.disconnect-btn" />
                          </Button>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            )}
          </CardBody>
        </Card>

        {/* Quick Reply Templates - Phase 2 */}
        <QuickReplySettings />

        {/* Auto Reply Rules - Phase 4 */}
        <AutoReplySettings />
      </div>
    );
  }

  renderEcommerceSettings() {
    const { shopeeShops, loadingEcommerce, ecommerceError, ecommerceSuccess } =
      this.state;

    return (
      <div>
        {ecommerceError && (
          <Alert color="danger" className="mb-3">
            {ecommerceError}
            <button
              className="close"
              onClick={() => this.setState({ ecommerceError: null })}
            >
              ×
            </button>
          </Alert>
        )}
        {ecommerceSuccess && (
          <Alert color="success" className="mb-3">
            {ecommerceSuccess}
            <button
              className="close"
              onClick={() => this.setState({ ecommerceSuccess: null })}
            >
              ×
            </button>
          </Alert>
        )}

        {/* Shopee Section */}
        <Card className="mb-4">
          <CardBody>
            <div className="d-flex justify-content-between align-items-start mb-3">
              <h5 className="mb-0">
                <span
                  className="mr-2"
                  style={{
                    display: "inline-block",
                    width: 24,
                    height: 24,
                    backgroundColor: "#EE4D2D",
                    borderRadius: 4,
                    textAlign: "center",
                    lineHeight: "24px",
                    color: "#fff",
                    fontWeight: "bold",
                    fontSize: 14,
                  }}
                >
                  S
                </span>
                Shopee
              </h5>
              <span
                id="shopeeGuide"
                className="text-primary"
                style={{ cursor: "pointer", fontSize: "13px" }}
                onClick={() =>
                  this.setState((prev) => ({
                    shopeeGuideOpen: !prev.shopeeGuideOpen,
                  }))
                }
              >
                <i className="simple-icon-question mr-1" />
                <IntlMessages id="settings.ecommerce.shopee.guide" />
              </span>
              <Popover
                placement="bottom-end"
                isOpen={this.state.shopeeGuideOpen}
                target="shopeeGuide"
                toggle={() =>
                  this.setState((prev) => ({
                    shopeeGuideOpen: !prev.shopeeGuideOpen,
                  }))
                }
              >
                <PopoverBody>
                  <strong>
                    <IntlMessages id="settings.ecommerce.shopee.guide.title" />
                  </strong>
                  <ol className="pl-3 mb-0 mt-2" style={{ fontSize: "13px" }}>
                    <li>
                      <IntlMessages id="settings.ecommerce.shopee.guide.step1" />
                    </li>
                    <li>
                      <IntlMessages id="settings.ecommerce.shopee.guide.step2" />
                    </li>
                    <li>
                      <IntlMessages id="settings.ecommerce.shopee.guide.step3" />
                    </li>
                    <li>
                      <IntlMessages id="settings.ecommerce.shopee.guide.step4" />
                    </li>
                    <li>
                      <IntlMessages id="settings.ecommerce.shopee.guide.step5" />
                    </li>
                  </ol>
                </PopoverBody>
              </Popover>
            </div>
            <p className="text-muted mb-3">
              <IntlMessages id="settings.ecommerce.shopee.desc" />
            </p>

            {
              /* Permission Check for Shopee */
              !this.checkPermission("pro") ? (
                <div className="mb-4">
                  <Alert color="warning">
                    <IntlMessages id="settings.ecommerce.upgrade-warning" />{" "}
                    <a
                      href="/app/applications/upgrade"
                      className="alert-link font-weight-bold"
                    >
                      <IntlMessages id="settings.zalo.upgrade-btn" />
                    </a>
                  </Alert>
                  <Button color="secondary" disabled className="mb-4">
                    <i className="simple-icon-lock mr-2" />
                    <IntlMessages id="settings.ecommerce.connect-locked" />
                  </Button>
                </div>
              ) : (
                <Button
                  style={{ backgroundColor: "#EE4D2D", borderColor: "#EE4D2D" }}
                  onClick={this.handleConnectShopee}
                  className="mb-4"
                >
                  <i className="simple-icon-plus mr-2" />
                  <IntlMessages id="settings.ecommerce.connect-btn" />
                </Button>
              )
            }

            {loadingEcommerce ? (
              <p className="text-muted">
                <IntlMessages id="settings.ecommerce.loading" />
              </p>
            ) : shopeeShops.length === 0 ? (
              <p className="text-muted">
                <IntlMessages id="settings.ecommerce.no-shop" />
              </p>
            ) : (
              <div className="table-responsive">
                <table className="table table-hover">
                  <thead>
                    <tr>
                      <th>
                        <IntlMessages id="settings.ecommerce.table.name" />
                      </th>
                      <th>
                        <IntlMessages id="settings.ecommerce.table.id" />
                      </th>
                      <th>
                        <IntlMessages id="settings.ecommerce.table.region" />
                      </th>
                      <th>
                        <IntlMessages id="settings.ecommerce.table.date" />
                      </th>
                      <th style={{ width: "120px" }}>
                        <IntlMessages id="settings.ecommerce.table.action" />
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {shopeeShops.map((shop) => (
                      <tr key={shop.id}>
                        <td>
                          <strong>{shop.shop_name}</strong>
                        </td>
                        <td>
                          <code>{shop.shop_id}</code>
                        </td>
                        <td>{shop.shop_region || "VN"}</td>
                        <td>
                          {new Date(shop.createdAt).toLocaleDateString("vi-VN")}
                        </td>
                        <td>
                          <Dropdown
                            isOpen={this.state.shopeeDropdownOpen[shop.shop_id]}
                            toggle={() =>
                              this.toggleShopeeDropdown(shop.shop_id)
                            }
                            size="sm"
                          >
                            <DropdownToggle caret color="primary" size="sm">
                              {this.state.syncingShopee[shop.shop_id] ? (
                                <IntlMessages id="settings.ecommerce.action.syncing" />
                              ) : (
                                <IntlMessages id="settings.ecommerce.table.action" />
                              )}
                            </DropdownToggle>
                            <DropdownMenu>
                              <DropdownItem
                                onClick={() =>
                                  this.handleSyncShopeeProducts(shop.shop_id)
                                }
                                disabled={
                                  !!this.state.syncingShopee[shop.shop_id]
                                }
                              >
                                <i className="simple-icon-cloud-download mr-2" />
                                <IntlMessages id="settings.ecommerce.action.import-product" />
                              </DropdownItem>
                              <DropdownItem
                                onClick={() =>
                                  this.handleSyncShopeeOrders(shop.shop_id)
                                }
                                disabled={
                                  !!this.state.syncingShopee[shop.shop_id]
                                }
                              >
                                <i className="simple-icon-refresh mr-2" />
                                <IntlMessages id="settings.ecommerce.action.sync-order" />
                              </DropdownItem>
                              <DropdownItem divider />
                              <DropdownItem
                                onClick={() =>
                                  this.handleDisconnectShopee(shop.shop_id)
                                }
                                className="text-danger"
                              >
                                <i className="simple-icon-logout mr-2" />
                                <IntlMessages id="settings.ecommerce.action.disconnect" />
                              </DropdownItem>
                            </DropdownMenu>
                          </Dropdown>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            )}
          </CardBody>
        </Card>

        {/* TikTok Shop Section */}
        <Card className="mb-4">
          <CardBody>
            <div className="d-flex justify-content-between align-items-start mb-3">
              <h5 className="mb-0">
                <span
                  className="mr-2"
                  style={{
                    display: "inline-block",
                    width: 24,
                    height: 24,
                    backgroundColor: "#000",
                    borderRadius: 4,
                    textAlign: "center",
                    lineHeight: "24px",
                    color: "#fff",
                    fontWeight: "bold",
                    fontSize: 12,
                  }}
                >
                  T
                </span>
                TikTok Shop
              </h5>
              <span
                id="tiktokGuide"
                className="text-primary"
                style={{ cursor: "pointer", fontSize: "13px" }}
                onClick={() =>
                  this.setState((prev) => ({
                    tiktokGuideOpen: !prev.tiktokGuideOpen,
                  }))
                }
              >
                <i className="simple-icon-question mr-1" />
                <IntlMessages id="settings.ecommerce.tiktok.guide" />
              </span>
              <Popover
                placement="bottom-end"
                isOpen={this.state.tiktokGuideOpen}
                target="tiktokGuide"
                toggle={() =>
                  this.setState((prev) => ({
                    tiktokGuideOpen: !prev.tiktokGuideOpen,
                  }))
                }
              >
                <PopoverBody>
                  <strong>
                    <IntlMessages id="settings.ecommerce.tiktok.guide.title" />
                  </strong>
                  <ol className="pl-3 mb-0 mt-2" style={{ fontSize: "13px" }}>
                    <li>
                      <IntlMessages id="settings.ecommerce.shopee.guide.step1" />
                    </li>
                    <li>
                      <IntlMessages id="settings.ecommerce.shopee.guide.step2" />
                    </li>
                    <li>
                      <IntlMessages id="settings.ecommerce.shopee.guide.step3" />
                    </li>
                    <li>
                      <IntlMessages id="settings.ecommerce.shopee.guide.step4" />
                    </li>
                    <li>
                      <IntlMessages id="settings.ecommerce.shopee.guide.step5" />
                    </li>
                  </ol>
                </PopoverBody>
              </Popover>
            </div>
            <p className="text-muted mb-3">
              <IntlMessages id="settings.ecommerce.tiktok.desc" />
            </p>

            {
              /* Permission Check for TikTok */
              !this.checkPermission("pro") ? (
                <div className="mb-4">
                  <Alert color="warning">
                    <IntlMessages id="settings.ecommerce.upgrade-warning" />{" "}
                    <a
                      href="/app/applications/upgrade"
                      className="alert-link font-weight-bold"
                    >
                      <IntlMessages id="settings.zalo.upgrade-btn" />
                    </a>
                  </Alert>
                  <Button color="secondary" disabled className="mb-4">
                    <i className="simple-icon-lock mr-2" />
                    <IntlMessages id="settings.ecommerce.connect-locked" />
                  </Button>
                </div>
              ) : (
                <Button
                  style={{ backgroundColor: "#000", borderColor: "#000" }}
                  onClick={this.handleConnectTiktok}
                  className="mb-4"
                >
                  <i className="simple-icon-plus mr-2" />
                  <IntlMessages id="settings.ecommerce.connect-btn" />
                </Button>
              )
            }

            {loadingEcommerce ? (
              <p className="text-muted">
                <IntlMessages id="settings.ecommerce.loading" />
              </p>
            ) : this.state.tiktokShops.length === 0 ? (
              <p className="text-muted">
                <IntlMessages id="settings.ecommerce.no-shop" />
              </p>
            ) : (
              <div className="table-responsive">
                <table className="table table-hover">
                  <thead>
                    <tr>
                      <th>
                        <IntlMessages id="settings.ecommerce.table.name" />
                      </th>
                      <th>
                        <IntlMessages id="settings.ecommerce.table.id" />
                      </th>
                      <th>
                        <IntlMessages id="settings.ecommerce.table.region" />
                      </th>
                      <th>
                        <IntlMessages id="settings.ecommerce.table.date" />
                      </th>
                      <th style={{ width: "120px" }}>
                        <IntlMessages id="settings.ecommerce.table.action" />
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {this.state.tiktokShops.map((shop) => (
                      <tr key={shop.id}>
                        <td>
                          <strong>{shop.shop_name}</strong>
                        </td>
                        <td>
                          <code>{shop.shop_id}</code>
                        </td>
                        <td>{shop.shop_region || "VN"}</td>
                        <td>
                          {new Date(shop.createdAt).toLocaleDateString("vi-VN")}
                        </td>
                        <td>
                          <Dropdown
                            isOpen={this.state.tiktokDropdownOpen[shop.shop_id]}
                            toggle={() =>
                              this.toggleTiktokDropdown(shop.shop_id)
                            }
                            size="sm"
                          >
                            <DropdownToggle caret color="dark" size="sm">
                              {this.state.syncingTiktok[shop.shop_id] ? (
                                <IntlMessages id="settings.ecommerce.action.syncing" />
                              ) : (
                                <IntlMessages id="settings.ecommerce.table.action" />
                              )}
                            </DropdownToggle>
                            <DropdownMenu>
                              <DropdownItem
                                onClick={() =>
                                  this.handleSyncTiktokProducts(shop.shop_id)
                                }
                                disabled={
                                  !!this.state.syncingTiktok[shop.shop_id]
                                }
                              >
                                <i className="simple-icon-cloud-download mr-2" />
                                <IntlMessages id="settings.ecommerce.action.import-product" />
                              </DropdownItem>
                              <DropdownItem
                                onClick={() =>
                                  this.handleSyncTiktokOrders(shop.shop_id)
                                }
                                disabled={
                                  !!this.state.syncingTiktok[shop.shop_id]
                                }
                              >
                                <i className="simple-icon-refresh mr-2" />
                                <IntlMessages id="settings.ecommerce.action.sync-order" />
                              </DropdownItem>
                              <DropdownItem divider />
                              <DropdownItem
                                onClick={() =>
                                  this.handleDisconnectTiktok(shop.shop_id)
                                }
                                className="text-danger"
                              >
                                <i className="simple-icon-logout mr-2" />
                                <IntlMessages id="settings.ecommerce.action.disconnect" />
                              </DropdownItem>
                            </DropdownMenu>
                          </Dropdown>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            )}
          </CardBody>
        </Card>
      </div>
    );
  }

  // E-Invoice Settings Tab
  renderEInvoiceSettings() {
    const { eInvoiceConfig, loadingEInvoice, eInvoiceError, eInvoiceSuccess } =
      this.state;

    return (
      <div>
        {eInvoiceError && <Alert color="danger">{eInvoiceError}</Alert>}
        {eInvoiceSuccess && <Alert color="success">{eInvoiceSuccess}</Alert>}

        {/* Header */}
        <div className="mb-4">
          <h5>
            <i className="simple-icon-doc mr-2" />
            <IntlMessages id="settings.einvoice.title" />
          </h5>
        </div>

        {!this.checkPermission("pro") && (
          <Alert color="warning" className="mb-4">
            <IntlMessages id="settings.einvoice.upgrade-warning" />{" "}
            <a
              href="/app/applications/upgrade"
              className="alert-link font-weight-bold"
            >
              <IntlMessages id="settings.zalo.upgrade-btn" />
            </a>
          </Alert>
        )}

        <div className={!this.checkPermission("pro") ? "overlay-blur" : ""}>
          <Row>
            {/* Card 1: General Configuration */}
            <Colxx md="6">
              <Card className="mb-4 h-100">
                <CardBody>
                  <h6 className="mb-4">
                    <i className="simple-icon-settings mr-2" />
                    <IntlMessages id="settings.general" />
                  </h6>

                  <FormGroup>
                    <Label>
                      <IntlMessages id="settings.einvoice.provider" />
                    </Label>
                    <Input
                      type="select"
                      value={eInvoiceConfig.provider}
                      onChange={(e) =>
                        this.handleEInvoiceConfigChange(
                          "provider",
                          e.target.value,
                        )
                      }
                    >
                      <option value="misa">Misa Meinvoice</option>
                      <option value="sepay">SePay eInvoice</option>
                    </Input>
                  </FormGroup>

                  <FormGroup className="mb-0">
                    <Label>
                      <IntlMessages id="settings.einvoice.vat-rate" />
                    </Label>
                    <Input
                      type="select"
                      value={eInvoiceConfig.vat_rate}
                      onChange={(e) =>
                        this.handleEInvoiceConfigChange(
                          "vat_rate",
                          e.target.value,
                        )
                      }
                    >
                      <option value="-1">KCT (Không chịu thuế)</option>
                      <option value="0">0%</option>
                      <option value="5">5%</option>
                      <option value="8">8%</option>
                      <option value="10">10%</option>
                    </Input>
                  </FormGroup>
                </CardBody>
              </Card>
            </Colxx>

            {/* Card 2: API Credentials */}
            <Colxx md="6">
              <Card className="mb-4 h-100">
                <CardBody>
                  <h6 className="mb-4">
                    <i className="simple-icon-lock mr-2" />
                    <IntlMessages id="settings.einvoice.api-info" />
                  </h6>

                  {/* SePay form */}
                  {eInvoiceConfig.provider === "sepay" && (
                    <>
                      <FormGroup>
                        <div className="d-flex justify-content-between">
                          <Label>
                            <IntlMessages id="settings.einvoice.api-url" />
                          </Label>
                          <div>
                            <span
                              id="sepayGuide"
                              className="text-primary"
                              style={{ cursor: "pointer", fontSize: "13px" }}
                              onClick={() =>
                                this.setState((prev) => ({
                                  sepayGuideOpen: !prev.sepayGuideOpen,
                                }))
                              }
                            >
                              <i className="simple-icon-question mr-1" />
                              Hướng dẫn tích hợp
                            </span>
                            <Popover
                              placement="bottom"
                              isOpen={this.state.sepayGuideOpen}
                              target="sepayGuide"
                              toggle={() =>
                                this.setState((prev) => ({
                                  sepayGuideOpen: !prev.sepayGuideOpen,
                                }))
                              }
                            >
                              <PopoverBody>
                                <strong>Cách lấy thông tin cấu hình:</strong>
                                <ol
                                  className="pl-3 mb-0 mt-2"
                                  style={{ fontSize: "13px" }}
                                >
                                  <li>
                                    Truy cập{" "}
                                    <a
                                      href="https://my.sepay.vn"
                                      target="_blank"
                                      rel="noopener noreferrer"
                                    >
                                      my.sepay.vn
                                    </a>{" "}
                                    &gt; Hóa đơn điện tử.
                                  </li>
                                  <li>
                                    Tạo/Copy <b>Client ID</b> và <b>Client Secret</b>.
                                  </li>
                                  <li>
                                    Copy <b>Account ID</b>,{" "}
                                    <b>Ký hiệu (Series)</b>,{" "}
                                    <b>Mẫu số (Template)</b>.
                                  </li>
                                  <li>Nhập các thông tin vào form bên dưới.</li>
                                  <li>
                                    Nhấn <b>Lưu cấu hình</b> và chọn{" "}
                                    <b>Test kết nối</b>.
                                  </li>
                                </ol>
                              </PopoverBody>
                            </Popover>
                          </div>
                        </div>
                        <Input
                          type="select"
                          value={eInvoiceConfig.api_url}
                          onChange={(e) =>
                            this.handleEInvoiceConfigChange(
                              "api_url",
                              e.target.value,
                            )
                          }
                        >
                          <option value="https://einvoice-api-sandbox.sepay.vn">
                            Sandbox: https://einvoice-api-sandbox.sepay.vn
                          </option>
                          <option value="https://einvoice-api.sepay.vn">
                            Production: https://einvoice-api.sepay.vn
                          </option>
                        </Input>
                      </FormGroup>

                      <Row>
                        <Colxx xs="6">
                          <FormGroup>
                            <Label>
                              {eInvoiceConfig.provider === "sepay" ? (
                                <IntlMessages id="settings.einvoice.sepay-client-id" />
                              ) : (
                                <IntlMessages id="settings.einvoice.username" />
                              )}
                            </Label>
                            <Input
                              value={eInvoiceConfig.username}
                              autoComplete="new-username"
                              onChange={(e) =>
                                this.handleEInvoiceConfigChange(
                                  "username",
                                  e.target.value,
                                )
                              }
                            />
                          </FormGroup>
                        </Colxx>
                        <Colxx xs="6">
                          <FormGroup>
                            <Label>
                              {eInvoiceConfig.provider === "sepay" ? (
                                <IntlMessages id="settings.einvoice.sepay-client-secret" />
                              ) : (
                                <IntlMessages id="settings.einvoice.password" />
                              )}
                            </Label>
                            <Input
                              type="password"
                              autoComplete="new-password"
                              value={eInvoiceConfig.password}
                              onChange={(e) =>
                                this.handleEInvoiceConfigChange(
                                  "password",
                                  e.target.value,
                                )
                              }
                            />
                          </FormGroup>
                        </Colxx>
                      </Row>

                      <div className="d-flex justify-content-between align-items-center mb-3">
                        <Button
                          color="info"
                          size="sm"
                          onClick={this.loadSepayAccounts}
                          disabled={this.state.loadingSepayInfo}
                        >
                          {this.state.loadingSepayInfo
                            ? "Loading..."
                            : "Tải danh sách Account"}
                        </Button>

                        {this.state.sepayQuota && (
                          <span className="text-success font-weight-bold">
                            Quota: {this.state.sepayQuota}
                          </span>
                        )}
                      </div>

                      <FormGroup>
                        <Label>ID Nhà cung cấp hóa đơn</Label>
                        <Input
                          type="select"
                          value={eInvoiceConfig.sepay_account_id}
                          onChange={(e) =>
                            this.handleSepayAccountChange(e.target.value)
                          }
                        >
                          <option value="">-- Chọn Account --</option>
                          {Array.isArray(this.state.sepayAccounts) &&
                            this.state.sepayAccounts.map((acc) => (
                              <option key={acc.id} value={acc.id}>
                                {acc.provider} - {acc.id}
                              </option>
                            ))}
                        </Input>
                      </FormGroup>

                      <Row>
                        <Colxx xs="6">
                          <FormGroup>
                            <Label>Invoice Template</Label>
                            <Input
                              type="select"
                              value={eInvoiceConfig.template_code}
                              onChange={(e) =>
                                this.handleEInvoiceConfigChange(
                                  "template_code",
                                  e.target.value,
                                )
                              }
                            >
                              <option value="">-- Chọn Mẫu số --</option>
                              {[
                                ...new Map(
                                  this.state.sepayTemplates.map((item) => [
                                    item.template_code,
                                    item,
                                  ]),
                                ).values(),
                              ].map((t) => (
                                <option
                                  key={t.template_code}
                                  value={t.template_code}
                                >
                                  {t.invoice_label}
                                </option>
                              ))}
                            </Input>
                          </FormGroup>
                        </Colxx>
                        <Colxx xs="6">
                          <FormGroup>
                            <Label>Invoice Series</Label>
                            <Input
                              type="select"
                              value={eInvoiceConfig.invoice_series}
                              onChange={(e) =>
                                this.handleEInvoiceConfigChange(
                                  "invoice_series",
                                  e.target.value,
                                )
                              }
                            >
                              <option value="">-- Chọn Ký hiệu --</option>
                              {[
                                ...new Set(
                                  this.state.sepayTemplates
                                    .filter(
                                      (t) =>
                                        t.template_code ===
                                        eInvoiceConfig.template_code,
                                    )
                                    .map((t) => t.invoice_series),
                                ),
                              ].map((s) => (
                                <option key={s} value={s}>
                                  {s}
                                </option>
                              ))}
                            </Input>
                          </FormGroup>
                        </Colxx>
                      </Row>
                    </>
                  )}

                  {/* MISA form */}
                  {eInvoiceConfig.provider === "misa" && (
                    <>
                      <FormGroup>
                        <div className="d-flex justify-content-between">
                          <Label>
                            <IntlMessages id="settings.einvoice.api-url" />
                          </Label>
                          <div>
                            <span
                              id="misaGuide"
                              className="text-primary"
                              style={{ cursor: "pointer", fontSize: "13px" }}
                              onClick={() =>
                                this.setState((prev) => ({
                                  misaGuideOpen: !prev.misaGuideOpen,
                                }))
                              }
                            >
                              <i className="simple-icon-question mr-1" />
                              Hướng dẫn tích hợp
                            </span>
                            <Popover
                              placement="bottom"
                              isOpen={this.state.misaGuideOpen}
                              target="misaGuide"
                              toggle={() =>
                                this.setState((prev) => ({
                                  misaGuideOpen: !prev.misaGuideOpen,
                                }))
                              }
                            >
                              <PopoverBody>
                                <strong>Cách lấy thông tin cấu hình:</strong>
                                <ol
                                  className="pl-3 mb-0 mt-2"
                                  style={{ fontSize: "13px" }}
                                >
                                  <li>
                                    Đăng ký/Đăng nhập tài khoản{" "}
                                    <a
                                      href="https://meinvoice.vn"
                                      target="_blank"
                                      rel="noopener noreferrer"
                                    >
                                      MISA Meinvoice
                                    </a>
                                    .
                                  </li>
                                  <li>
                                    Xác định môi trường (Test/Production) và
                                    chọn API URL tương ứng.
                                  </li>
                                  <li>
                                    Nhập <b>Username</b> và <b>Password</b> tài
                                    khoản MISA của bạn.
                                  </li>
                                  <li>
                                    Nhấn <b>Lưu cấu hình</b> để hệ thống kiểm
                                    tra kết nối.
                                  </li>
                                </ol>
                              </PopoverBody>
                            </Popover>
                          </div>
                        </div>
                        <Input
                          type="select"
                          value={eInvoiceConfig.api_url}
                          onChange={(e) =>
                            this.handleEInvoiceConfigChange(
                              "api_url",
                              e.target.value,
                            )
                          }
                        >
                          <option value="https://testapi.meinvoice.vn">
                            Test: https://testapi.meinvoice.vn
                          </option>
                          <option value="https://api.meinvoice.vn">
                            Production: https://api.meinvoice.vn
                          </option>
                        </Input>
                        <small className="text-muted">
                          <IntlMessages id="settings.einvoice.api-url-help" />
                        </small>
                      </FormGroup>

                      <Row>
                        <Colxx xs="6">
                          <FormGroup className="mb-0">
                            <Label>
                              <IntlMessages id="settings.einvoice.username" />
                            </Label>
                            <Input
                              value={eInvoiceConfig.username}
                              onChange={(e) =>
                                this.handleEInvoiceConfigChange(
                                  "username",
                                  e.target.value,
                                )
                              }
                            />
                          </FormGroup>
                        </Colxx>
                        <Colxx xs="6">
                          <FormGroup className="mb-0">
                            <Label>
                              <IntlMessages id="settings.einvoice.password" />
                            </Label>
                            <Input
                              type="password"
                              value={eInvoiceConfig.password}
                              onChange={(e) =>
                                this.handleEInvoiceConfigChange(
                                  "password",
                                  e.target.value,
                                )
                              }
                            />
                          </FormGroup>
                        </Colxx>
                      </Row>
                    </>
                  )}
                </CardBody>
              </Card>
            </Colxx>

            {/* Card 4: Automation Configuration */}
            <Colxx md="12">
              <Card className="mb-4 mt-4">
                <CardBody>
                  <h6 className="mb-4">
                    <i className="simple-icon-wrench mr-2" />
                    <IntlMessages id="settings.einvoice.automation" />
                  </h6>
                  <div className="d-flex align-items-center mb-3">
                    <Switch
                      className="custom-switch custom-switch-primary custom-switch-small"
                      checked={eInvoiceConfig.auto_issue}
                      onChange={(checked) =>
                        this.handleEInvoiceConfigChange("auto_issue", checked)
                      }
                    />
                    <Label className="mb-0 ml-2">
                      <IntlMessages id="settings.einvoice.auto-issue" />
                    </Label>
                  </div>
                  <div className="d-flex align-items-center">
                    <Switch
                      className="custom-switch custom-switch-primary custom-switch-small"
                      checked={eInvoiceConfig.create_draft_when_not_issue}
                      onChange={(checked) =>
                        this.handleEInvoiceConfigChange(
                          "create_draft_when_not_issue",
                          checked,
                        )
                      }
                    />
                    <Label className="mb-0 ml-2">
                      <IntlMessages id="settings.einvoice.auto-draft" />
                    </Label>
                  </div>
                </CardBody>
              </Card>
            </Colxx>

            {/* Card 3: Company Information */}
            {eInvoiceConfig.provider !== "sepay" && (
              <Colxx md="12">
                <Card className="mt-4">
                  <CardBody>
                    <h6 className="mb-4">
                      <i className="simple-icon-briefcase mr-2" />
                      <IntlMessages id="settings.einvoice.company-info" />
                    </h6>

                    <Row>
                      <Colxx md="4">
                        <FormGroup>
                          <Label>
                            <IntlMessages id="settings.einvoice.tax-id" />
                          </Label>
                          <Input
                            value={eInvoiceConfig.company_tax_id}
                            onChange={(e) =>
                              this.handleEInvoiceConfigChange(
                                "company_tax_id",
                                e.target.value,
                              )
                            }
                          />
                        </FormGroup>
                      </Colxx>

                      <Colxx md="4">
                        <FormGroup>
                          <Label>
                            <IntlMessages id="settings.einvoice.company-name" />
                          </Label>
                          <Input
                            value={eInvoiceConfig.company_name}
                            onChange={(e) =>
                              this.handleEInvoiceConfigChange(
                                "company_name",
                                e.target.value,
                              )
                            }
                          />
                        </FormGroup>
                      </Colxx>

                      <Colxx md="4">
                        <FormGroup>
                          <Label>
                            <IntlMessages id="settings.einvoice.series" />
                          </Label>
                          <Input
                            value={eInvoiceConfig.invoice_series}
                            onChange={(e) =>
                              this.handleEInvoiceConfigChange(
                                "invoice_series",
                                e.target.value,
                              )
                            }
                          />
                        </FormGroup>
                      </Colxx>

                      <Colxx md="12">
                        <FormGroup>
                          <Label>
                            <IntlMessages id="settings.einvoice.address" />
                          </Label>
                          <Input
                            value={eInvoiceConfig.company_address}
                            onChange={(e) =>
                              this.handleEInvoiceConfigChange(
                                "company_address",
                                e.target.value,
                              )
                            }
                          />
                        </FormGroup>
                      </Colxx>

                      <Colxx md="3">
                        <FormGroup>
                          <Label>
                            <IntlMessages id="settings.einvoice.phone" />
                          </Label>
                          <Input
                            value={eInvoiceConfig.company_phone}
                            onChange={(e) =>
                              this.handleEInvoiceConfigChange(
                                "company_phone",
                                e.target.value,
                              )
                            }
                          />
                        </FormGroup>
                      </Colxx>

                      <Colxx md="3">
                        <FormGroup>
                          <Label>
                            <IntlMessages id="settings.einvoice.email" />
                          </Label>
                          <Input
                            value={eInvoiceConfig.company_email}
                            onChange={(e) =>
                              this.handleEInvoiceConfigChange(
                                "company_email",
                                e.target.value,
                              )
                            }
                          />
                        </FormGroup>
                      </Colxx>

                      <Colxx md="3">
                        <FormGroup>
                          <Label>
                            <IntlMessages id="settings.einvoice.bank-account" />
                          </Label>
                          <Input
                            value={eInvoiceConfig.company_bank_account}
                            onChange={(e) =>
                              this.handleEInvoiceConfigChange(
                                "company_bank_account",
                                e.target.value,
                              )
                            }
                          />
                        </FormGroup>
                      </Colxx>

                      <Colxx md="3">
                        <FormGroup>
                          <Label>
                            <IntlMessages id="settings.einvoice.bank-name" />
                          </Label>
                          <Input
                            value={eInvoiceConfig.company_bank_name}
                            onChange={(e) =>
                              this.handleEInvoiceConfigChange(
                                "company_bank_name",
                                e.target.value,
                              )
                            }
                          />
                        </FormGroup>
                      </Colxx>
                    </Row>
                  </CardBody>
                </Card>
              </Colxx>
            )}

            {/* Card 4: Signing Method & Actions */}
            {/* Card 4: Signing Method & Actions */}
            <Colxx md="12">
              <Card className="mt-4 mb-5">
                <CardBody>
                  {eInvoiceConfig.provider !== "sepay" && (
                    <>
                      <h6 className="mb-4">
                        <i className="simple-icon-key mr-2" />
                        <IntlMessages id="settings.einvoice.signing-method" />
                      </h6>

                      <Row>
                        <Colxx md="4">
                          <FormGroup>
                            <Label>
                              <IntlMessages id="settings.einvoice.sign-type" />
                            </Label>
                            <Input
                              type="select"
                              value={eInvoiceConfig.sign_type}
                              onChange={(e) =>
                                this.handleEInvoiceConfigChange(
                                  "sign_type",
                                  parseInt(e.target.value, 10),
                                )
                              }
                            >
                              <option value={1}>USB Token (Ký thủ công)</option>
                              <option value={2}>HSM (Ký tự động server)</option>
                              <option value={3}>
                                eSign nâng cao (Ký từ xa)
                              </option>
                            </Input>
                            <small className="text-muted">
                              <IntlMessages id="settings.einvoice.sign-type-help" />
                            </small>
                          </FormGroup>
                        </Colxx>

                        {/* eSign Configuration (conditional) */}
                        {eInvoiceConfig.sign_type === 3 && (
                          <>
                            <Colxx md="4">
                              <FormGroup>
                                <Label>
                                  <IntlMessages id="settings.einvoice.esign-provider" />
                                </Label>
                                <Input
                                  type="select"
                                  value={eInvoiceConfig.esign_provider}
                                  onChange={(e) =>
                                    this.handleEInvoiceConfigChange(
                                      "esign_provider",
                                      e.target.value,
                                    )
                                  }
                                >
                                  <option value="">
                                    -- Chọn nhà cung cấp CA --
                                  </option>
                                  <option value="vnpt-ca">VNPT-CA</option>
                                  <option value="viettel-ca">Viettel-CA</option>
                                  <option value="bkav-ca">BKAV-CA</option>
                                  <option value="fpt-ca">FPT-CA</option>
                                </Input>
                              </FormGroup>
                            </Colxx>

                            <Colxx md="4">
                              <FormGroup>
                                <Label>
                                  <IntlMessages id="settings.einvoice.esign-serial" />
                                </Label>
                                <Input
                                  value={eInvoiceConfig.esign_serial}
                                  placeholder="VD: 01000A5B7C..."
                                  onChange={(e) =>
                                    this.handleEInvoiceConfigChange(
                                      "esign_serial",
                                      e.target.value,
                                    )
                                  }
                                />
                              </FormGroup>
                            </Colxx>

                            <Colxx md="6">
                              <FormGroup>
                                <Label>
                                  <IntlMessages id="settings.einvoice.esign-username" />
                                </Label>
                                <Input
                                  value={eInvoiceConfig.esign_username}
                                  onChange={(e) =>
                                    this.handleEInvoiceConfigChange(
                                      "esign_username",
                                      e.target.value,
                                    )
                                  }
                                />
                              </FormGroup>
                            </Colxx>

                            <Colxx md="6">
                              <FormGroup>
                                <Label>
                                  <IntlMessages id="settings.einvoice.esign-password" />
                                </Label>
                                <Input
                                  type="password"
                                  value={eInvoiceConfig.esign_password}
                                  onChange={(e) =>
                                    this.handleEInvoiceConfigChange(
                                      "esign_password",
                                      e.target.value,
                                    )
                                  }
                                />
                              </FormGroup>
                            </Colxx>
                          </>
                        )}
                      </Row>
                    </>
                  )}

                  {/* Test Connection Result */}
                  {this.state.testConnectionResult && (
                    <Alert
                      color={
                        this.state.testConnectionResult.success
                          ? "success"
                          : "danger"
                      }
                      className="mt-3"
                    >
                      {this.state.testConnectionResult.message}
                    </Alert>
                  )}

                  <div className="d-flex justify-content-between mt-4">
                    <Button
                      color="secondary"
                      outline
                      onClick={this.testEInvoiceConnection}
                      disabled={this.state.testingConnection || loadingEInvoice}
                    >
                      {this.state.testingConnection ? (
                        <>
                          <i className="simple-icon-refresh mr-2" />
                          <IntlMessages id="settings.einvoice.testing" />
                        </>
                      ) : (
                        <>
                          <i className="simple-icon-link mr-2" />
                          <IntlMessages id="settings.einvoice.test-connection" />
                        </>
                      )}
                    </Button>

                    <Button
                      color="primary"
                      onClick={this.saveEInvoiceConfig}
                      disabled={loadingEInvoice}
                    >
                      {loadingEInvoice ? (
                        <IntlMessages id="settings.einvoice.saving" />
                      ) : (
                        <IntlMessages id="settings.einvoice.save-btn" />
                      )}
                    </Button>
                  </div>
                </CardBody>
              </Card>
            </Colxx>
          </Row>
        </div>
      </div>
    );
  }

  // ========== RENDER EMAIL SETTINGS ==========
  renderEmailSettings() {
    const {
      emailConfig,
      loadingEmailConfig,
      emailConfigError,
      emailConfigSuccess,
      showEmailPassword,
      emailGuideOpen,
    } = this.state;

    return (
      <div>
        {emailConfigError && (
          <Alert color="danger" className="mb-3">
            {emailConfigError}
            <button
              className="close"
              onClick={() => this.setState({ emailConfigError: null })}
            >
              ×
            </button>
          </Alert>
        )}
        {emailConfigSuccess && (
          <Alert color="success" className="mb-3">
            {emailConfigSuccess}
            <button
              className="close"
              onClick={() => this.setState({ emailConfigSuccess: null })}
            >
              ×
            </button>
          </Alert>
        )}

        <Card className="mb-4">
          <CardBody>
            <div className="d-flex justify-content-between align-items-start mb-3">
              <h5 className="mb-0">
                <i
                  className="simple-icon-envelope mr-2"
                  style={{ color: "#ea4335" }}
                />
                <IntlMessages id="settings.nav.email" />
              </h5>
              <span
                id="emailGuide"
                className="text-primary"
                style={{ cursor: "pointer", fontSize: "13px" }}
                onClick={() =>
                  this.setState((prev) => ({
                    emailGuideOpen: !prev.emailGuideOpen,
                  }))
                }
              >
                <i className="simple-icon-question mr-1" />
                <IntlMessages id="settings.email.guide-button" />
              </span>
              <Popover
                placement="bottom-end"
                isOpen={emailGuideOpen}
                target="emailGuide"
                toggle={() =>
                  this.setState((prev) => ({
                    emailGuideOpen: !prev.emailGuideOpen,
                  }))
                }
              >
                <PopoverBody style={{ maxWidth: "400px" }}>
                  <strong>
                    <IntlMessages id="settings.email.guide-title" />
                  </strong>
                  <ol className="pl-3 mb-2 mt-2" style={{ fontSize: "13px" }}>
                    <li>
                      <IntlMessages id="settings.email.guide-step-1" />{" "}
                      <a
                        href="https://myaccount.google.com/"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        Google Account
                      </a>
                    </li>
                    <li>
                      <IntlMessages id="settings.email.guide-step-2" />
                    </li>
                    <li>
                      <IntlMessages id="settings.email.guide-step-3" />{" "}
                      <a
                        href="https://myaccount.google.com/apppasswords"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        nhấn vào đây
                      </a>
                    </li>
                    <li>
                      <IntlMessages id="settings.email.guide-step-4" />
                    </li>
                    <li>
                      <IntlMessages id="settings.email.guide-step-5" />
                    </li>
                  </ol>
                  <hr />
                  <strong>
                    <IntlMessages id="settings.email.smtp-custom-title" />
                  </strong>
                  <ul className="pl-3 mb-0" style={{ fontSize: "13px" }}>
                    <li>Zoho: smtp.zoho.com, port 465, SSL</li>
                    <li>Office 365: smtp.office365.com, port 587, TLS</li>
                  </ul>
                </PopoverBody>
              </Popover>
            </div>

            <p className="text-muted mb-4">
              <IntlMessages id="settings.email.description" />
            </p>

            {/* Enable/Disable */}
            <div className="mb-4">
              <div className="mb-2">
                <div className="custom-control custom-radio mb-2">
                  <input
                    type="radio"
                    id="emailModeDefault"
                    name="emailMode"
                    className="custom-control-input"
                    checked={!emailConfig.enabled}
                    onChange={() =>
                      this.handleEmailConfigChange("enabled", false)
                    }
                  />
                  <label
                    className="custom-control-label"
                    htmlFor="emailModeDefault"
                  >
                    <IntlMessages id="settings.email.mode-default" />
                  </label>
                </div>
                <div className="custom-control custom-radio">
                  <input
                    type="radio"
                    id="emailModeCustom"
                    name="emailMode"
                    className="custom-control-input"
                    checked={emailConfig.enabled}
                    onChange={() =>
                      this.handleEmailConfigChange("enabled", true)
                    }
                  />
                  <label
                    className="custom-control-label"
                    htmlFor="emailModeCustom"
                  >
                    <IntlMessages id="settings.email.mode-custom" />
                  </label>
                </div>
              </div>
              {!emailConfig.enabled && (
                <small className="text-muted d-block mt-2">
                  <IntlMessages id="settings.email.default-note" />
                </small>
              )}
            </div>

            {emailConfig.enabled && (
              <>
                {/* Email Type Selection */}
                <div className="mb-4">
                  <label className="font-weight-bold">
                    <IntlMessages id="settings.email.type-label" />
                  </label>
                  <div className="mt-2">
                    <div className="custom-control custom-radio custom-control-inline">
                      <input
                        type="radio"
                        id="emailTypeGmail"
                        name="emailType"
                        className="custom-control-input"
                        checked={emailConfig.type === "gmail"}
                        onChange={() =>
                          this.handleEmailConfigChange("type", "gmail")
                        }
                      />
                      <label
                        className="custom-control-label"
                        htmlFor="emailTypeGmail"
                      >
                        <i
                          className="iconsminds-mail mr-1"
                          style={{ color: "#ea4335" }}
                        />
                        <IntlMessages id="settings.email.type-gmail" />
                      </label>
                    </div>
                    <div className="custom-control custom-radio custom-control-inline">
                      <input
                        type="radio"
                        id="emailTypeSmtp"
                        name="emailType"
                        className="custom-control-input"
                        checked={emailConfig.type === "smtp"}
                        onChange={() =>
                          this.handleEmailConfigChange("type", "smtp")
                        }
                      />
                      <label
                        className="custom-control-label"
                        htmlFor="emailTypeSmtp"
                      >
                        <i className="simple-icon-globe mr-1" />
                        <IntlMessages id="settings.email.type-smtp" />
                      </label>
                    </div>
                  </div>
                </div>

                {/* Email & Password */}
                <Row>
                  <Colxx md={6}>
                    <div className="form-group">
                      <label>
                        <IntlMessages id="settings.email.address-label" />{" "}
                        <span className="text-danger">*</span>
                      </label>
                      <input
                        type="email"
                        className="form-control"
                        value={emailConfig.email}
                        onChange={(e) =>
                          this.handleEmailConfigChange("email", e.target.value)
                        }
                        placeholder={
                          emailConfig.type === "gmail"
                            ? this.props.intl.formatMessage({
                                id: "settings.email.placeholder.gmail-email",
                              })
                            : this.props.intl.formatMessage({
                                id: "settings.email.placeholder.smtp-email",
                              })
                        }
                      />
                    </div>
                  </Colxx>
                  <Colxx md={6}>
                    <div className="form-group">
                      <label>
                        {emailConfig.type === "gmail" ? (
                          <IntlMessages id="settings.email.app-password-label" />
                        ) : (
                          <IntlMessages id="settings.email.password-label" />
                        )}{" "}
                        <span className="text-danger">*</span>
                      </label>
                      <div className="input-group">
                        <input
                          type={showEmailPassword ? "text" : "password"}
                          className="form-control"
                          value={emailConfig.password}
                          onChange={(e) =>
                            this.handleEmailConfigChange(
                              "password",
                              e.target.value,
                            )
                          }
                          placeholder={
                            emailConfig.type === "gmail"
                              ? "abcd efgh ijkl mnop"
                              : this.props.intl.formatMessage({
                                  id: "settings.einvoice.password",
                                })
                          }
                        />
                        <div className="input-group-append">
                          <button
                            className="btn btn-outline-secondary"
                            type="button"
                            onClick={() =>
                              this.setState((prev) => ({
                                showEmailPassword: !prev.showEmailPassword,
                              }))
                            }
                          >
                            <i
                              className={
                                showEmailPassword
                                  ? "simple-icon-eye"
                                  : "simple-icon-eye"
                              }
                            />
                          </button>
                        </div>
                      </div>
                      {emailConfig.type === "gmail" && (
                        <small className="text-muted">
                          <a
                            href="https://myaccount.google.com/apppasswords"
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            <IntlMessages id="settings.email.create-app-password" />
                          </a>
                        </small>
                      )}
                    </div>
                  </Colxx>
                </Row>

                {/* SMTP Fields (only for smtp type) */}
                {emailConfig.type === "smtp" && (
                  <>
                    <hr />
                    <h6 className="mb-3">
                      <IntlMessages id="settings.email.smtp-server-config" />
                    </h6>
                    <Row>
                      <Colxx md={6}>
                        <div className="form-group">
                          <label>
                            <IntlMessages id="settings.email.smtp-host" />{" "}
                            <span className="text-danger">*</span>
                          </label>
                          <input
                            type="text"
                            className="form-control"
                            value={emailConfig.smtp_host}
                            onChange={(e) =>
                              this.handleEmailConfigChange(
                                "smtp_host",
                                e.target.value,
                              )
                            }
                            placeholder="smtp.example.com"
                          />
                        </div>
                      </Colxx>
                      <Colxx md={3}>
                        <div className="form-group">
                          <label>
                            <IntlMessages id="settings.email.smtp-port" />
                          </label>
                          <input
                            type="number"
                            className="form-control"
                            value={emailConfig.smtp_port}
                            onChange={(e) =>
                              this.handleEmailConfigChange(
                                "smtp_port",
                                parseInt(e.target.value) || 465,
                              )
                            }
                            placeholder="465"
                          />
                        </div>
                      </Colxx>
                      <Colxx md={3}>
                        <div className="form-group">
                          <label>
                            <IntlMessages id="settings.email.smtp-secure" />
                          </label>
                          <select
                            className="form-control"
                            value={emailConfig.smtp_secure ? "ssl" : "tls"}
                            onChange={(e) =>
                              this.handleEmailConfigChange(
                                "smtp_secure",
                                e.target.value === "ssl",
                              )
                            }
                          >
                            <option value="ssl">SSL (Port 465)</option>
                            <option value="tls">TLS (Port 587)</option>
                          </select>
                        </div>
                      </Colxx>
                    </Row>

                    {/* Common SMTP presets */}
                    <div className="mb-3">
                      <small className="text-muted">
                        <IntlMessages id="settings.email.quick-config" />{" "}
                      </small>
                      <Button
                        size="xs"
                        color="light"
                        className="mr-2"
                        onClick={() => {
                          this.handleEmailConfigChange(
                            "smtp_host",
                            "smtp.zoho.com",
                          );
                          this.handleEmailConfigChange("smtp_port", 465);
                          this.handleEmailConfigChange("smtp_secure", true);
                        }}
                      >
                        Zoho Mail
                      </Button>
                      <Button
                        size="xs"
                        color="light"
                        className="mr-2"
                        onClick={() => {
                          this.handleEmailConfigChange(
                            "smtp_host",
                            "smtp.office365.com",
                          );
                          this.handleEmailConfigChange("smtp_port", 587);
                          this.handleEmailConfigChange("smtp_secure", false);
                        }}
                      >
                        Office 365
                      </Button>
                      <Button
                        size="xs"
                        color="light"
                        onClick={() => {
                          this.handleEmailConfigChange(
                            "smtp_host",
                            "smtp.sendgrid.net",
                          );
                          this.handleEmailConfigChange("smtp_port", 587);
                          this.handleEmailConfigChange("smtp_secure", false);
                        }}
                      >
                        SendGrid
                      </Button>
                    </div>
                  </>
                )}

                {/* Action Buttons */}
                <div className="d-flex justify-content-between mt-4">
                  <Button
                    color="outline-secondary"
                    onClick={this.testEmailConfig}
                    disabled={
                      loadingEmailConfig ||
                      !emailConfig.email ||
                      !emailConfig.password
                    }
                  >
                    <i className="simple-icon-paper-plane mr-2" />
                    <IntlMessages id="settings.email.test-button" />
                  </Button>
                  <Button
                    color="primary"
                    onClick={this.saveEmailConfig}
                    disabled={loadingEmailConfig}
                  >
                    {loadingEmailConfig ? (
                      <IntlMessages id="settings.email.saving" />
                    ) : (
                      <IntlMessages id="settings.email.save-button" />
                    )}
                  </Button>
                </div>
              </>
            )}
          </CardBody>
        </Card>
      </div>
    );
  }

  render() {
    const { activeTab } = this.state;

    return !this.state.isLoading ? (
      <div className="loading" />
    ) : (
      <React.Fragment>
        {/* <Row>
          <Colxx xxs="12">
            <Breadcrumb heading="menu.setting" match={this.props.match} />
            <Separator className="mb-5" />
          </Colxx>
        </Row> */}

        <Nav tabs className="separator-tabs ml-0 mb-5">
          <NavItem>
            <NavLink
              className={classnames({
                active: activeTab === "1",
                "nav-link": true,
              })}
              onClick={() => this.toggleTab("1")}
              style={{ cursor: "pointer" }}
            >
              <i className="simple-icon-settings mr-2" />
              <IntlMessages id="settings.nav.general" />
            </NavLink>
          </NavItem>
          <NavItem>
            <NavLink
              className={classnames({
                active: activeTab === "2",
                "nav-link": true,
              })}
              onClick={() => this.toggleTab("2")}
              style={{ cursor: "pointer" }}
            >
              <i className="iconsminds-printer mr-2" />
              <IntlMessages id="settings.nav.invoice" />
            </NavLink>
          </NavItem>
          <NavItem>
            <NavLink
              className={classnames({
                active: activeTab === "3",
                "nav-link": true,
              })}
              onClick={() => this.toggleTab("3")}
              style={{ cursor: "pointer" }}
            >
              <i className="simple-icon-share-alt mr-2" />
              <IntlMessages id="settings.nav.social" />
            </NavLink>
          </NavItem>
          <NavItem>
            <NavLink
              className={classnames({
                active: activeTab === "4",
                "nav-link": true,
              })}
              onClick={() => this.toggleTab("4")}
              style={{ cursor: "pointer" }}
            >
              <i className="iconsminds-box-with-folders mr-2" />
              <IntlMessages id="settings.nav.shipping" />
            </NavLink>
          </NavItem>
          <NavItem>
            <NavLink
              className={classnames({
                active: activeTab === "5",
                "nav-link": true,
              })}
              onClick={() => this.toggleTab("5")}
              style={{ cursor: "pointer" }}
            >
              <i className="simple-icon-people mr-2" />
              <IntlMessages id="settings.nav.staff" />
            </NavLink>
          </NavItem>
          <NavItem>
            <NavLink
              className={classnames({
                active: activeTab === "6",
                "nav-link": true,
              })}
              onClick={() => this.toggleTab("6")}
              style={{ cursor: "pointer" }}
            >
              <i className="simple-icon-heart mr-2" />
              <IntlMessages id="settings.nav.customer" />
            </NavLink>
          </NavItem>
          <NavItem>
            <NavLink
              className={classnames({
                active: activeTab === "7",
                "nav-link": true,
              })}
              onClick={() => this.toggleTab("7")}
              style={{ cursor: "pointer" }}
            >
              <i className="simple-icon-basket mr-2" />
              <IntlMessages id="settings.nav.ecommerce" />
            </NavLink>
          </NavItem>
          <NavItem>
            <NavLink
              className={classnames({
                active: activeTab === "8",
                "nav-link": true,
              })}
              onClick={() => this.toggleTab("8")}
              style={{ cursor: "pointer" }}
            >
              <i className="simple-icon-doc mr-2" />
              <IntlMessages id="settings.nav.einvoice" />
            </NavLink>
          </NavItem>
          <NavItem>
            <NavLink
              className={classnames({
                active: activeTab === "9",
                "nav-link": true,
              })}
              onClick={() => this.toggleTab("9")}
              style={{ cursor: "pointer" }}
            >
              <i className="simple-icon-key mr-2" />
              <IntlMessages id="settings.nav.apikeys" />
            </NavLink>
          </NavItem>
          <NavItem>
            <NavLink
              className={classnames({
                active: activeTab === "10",
                "nav-link": true,
              })}
              onClick={() => this.toggleTab("10")}
              style={{ cursor: "pointer" }}
            >
              <i className="simple-icon-bell mr-2" />
              <IntlMessages id="settings.nav.webhooks" />
            </NavLink>
          </NavItem>
          <NavItem>
            <NavLink
              className={classnames({
                active: activeTab === "11",
                "nav-link": true,
              })}
              onClick={() => this.toggleTab("11")}
              style={{ cursor: "pointer" }}
            >
              <i className="simple-icon-envelope mr-2" />
              <IntlMessages id="settings.nav.email" />
            </NavLink>
          </NavItem>
          <NavItem>
            <NavLink
              className={classnames({
                active: activeTab === "12",
                "nav-link": true,
              })}
              onClick={() => this.toggleTab("12")}
              style={{ cursor: "pointer" }}
            >
              <i className="simple-icon-magic-wand mr-2" />
              <IntlMessages id="settings.nav.ai" />
            </NavLink>
          </NavItem>
        </Nav>

        <TabContent activeTab={activeTab}>
          <TabPane tabId="1">{this.renderGeneralSettings()}</TabPane>
          <TabPane tabId="2">{this.renderInvoiceSettings()}</TabPane>
          <TabPane tabId="3">{this.renderSocialSettings()}</TabPane>
          <TabPane tabId="4">
            <ShippingSettingsContent license={this.state.license} />
          </TabPane>
          <TabPane tabId="5">
            <StaffSettingsContent />
          </TabPane>
          <TabPane tabId="6">
            <CustomerSettingsContent />
          </TabPane>
          <TabPane tabId="7">{this.renderEcommerceSettings()}</TabPane>
          <TabPane tabId="8">{this.renderEInvoiceSettings()}</TabPane>
          <TabPane tabId="9">
            <PartnerManagement license={this.state.license} />
          </TabPane>
          <TabPane tabId="10">
            <WebhookManagement license={this.state.license} />
          </TabPane>
          <TabPane tabId="11">{this.renderEmailSettings()}</TabPane>

          <TabPane tabId="12">
            <AIConfiguration />
          </TabPane>
        </TabContent>
      </React.Fragment>
    );
  }
}

const mapStateToProps = ({ menu }) => {
  const { menuLayoutType, menuCollapsed } = menu;
  return {
    menuLayoutType,
    menuCollapsed,
  };
};

const mapDispatchToProps = {
  setSearchContext,
  setMenuLayoutType,
};

export default injectIntl(connect(mapStateToProps, mapDispatchToProps)(Setting));
